// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/RobotoMono-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/RobotoMono-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/RobotoMono-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/RobotoMono-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/Montserrat-Thin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/Montserrat-Thin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/delegation.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/liquidity.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/danate.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../images/check-solid.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@font-face {
  font-family: "Roboto Mono It";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: normal;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: "Roboto Mono Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
  font-weight: 100;
  font-style: normal;
  font-display: swap;
}
/* VARIABLES */
/* MIXINS */
/* RESET CSS */
/* http://meyerweb.com/eric/tools/css/reset/
         v2.0 | 20110126
         License: none (public domain)
      */
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  color: inherit;
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

* {
  box-sizing: border-box;
}

a {
  text-decoration: none;
}
a, a:hover, a:active, a:visited, a:focus {
  color: inherit;
}

i,
em,
.italic-text {
  font-style: italic;
}

.left {
  float: left;
}

.right {
  float: right;
}

.wrap-clear::after {
  content: "";
  display: block;
  clear: both;
}

.clearfix {
  zoom: 1;
  display: table;
  clear: both;
}
.clearfix:before, .clearfix:after {
  content: "";
  display: table;
}
.clearfix:after {
  clear: both;
}

:focus {
  outline: none;
}

input,
button,
textarea {
  border-radius: 0;
  appearance: none;
}

select {
  border-radius: 0;
}

textarea {
  resize: none;
}

/* COMMONS */
body {
  -webkit-font-smoothing: antialiased;
  letter-spacing: 0.6px;
}

ol,
ul {
  margin: 0px;
}

button,
input,
select,
textarea {
  -webkit-appearance: none;
  outline: none;
  border-radius: 0;
  background-color: transparent;
}

input,
textarea {
  background: transparent;
  border: none;
}

input:focus,
select:focus,
textarea:focus,
button:focus,
a:focus {
  outline: none;
}

a {
  color: inherit;
  cursor: pointer;
}

.h1,
.h2,
.h3,
.h4,
h1,
h2,
h3,
h4 {
  line-height: 1.2;
}

p {
  line-height: 1.3;
}

img {
  display: block;
  max-width: 100%;
  height: auto;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.slick-next:before,
.slick-prev:before {
  content: "";
}

.scroll-lock {
  height: 100%;
  overflow-y: hidden;
}
small {
  font-size: 13px;
}

.input[type=checkbox] {
  -webkit-appearance: checkbox;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

@media only screen and (min-width: 1025px) {
  .hidden-lg {
    display: none !important;
  }
}

@media (max-width: 767px) {
  .hidden-xs {
    display: none !important;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .hidden-md {
    display: none !important;
  }
}

.img-responsive {
  width: 100%;
  height: auto;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  width: 90%;
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .container {
    width: 90%;
    max-width: 768px;
    margin: 0 auto;
  }
}
@media (max-width: 767px) {
  .container {
    width: 100%;
    padding: 0 20px;
    margin: 0 auto;
  }
}

.common-bg {
  background-position: center;
  background-repeat: no-repeat;
}

p {
  font-size: 15px;
}
@media (max-width: 767px) {
  p {
    font-size: 15px;
  }
}

h2 {
  font-weight: 600;
}

@media (max-width: 767px) {
  main {
    padding-top: 65px;
  }
}

header {
  background-color: #3b20e2;
}
header .logo {
  color: white;
  font-family: "Roboto Mono Regular";
  font-size: 26px;
  line-height: 1.2;
}
header a {
  color: white;
  font-family: "Roboto Mono Regular";
  display: inline-block;
  font-size: 19px;
  line-height: 1.2;
}
header .navbar {
  padding-top: 32px;
  padding-bottom: 32px;
  display: flex;
  justify-content: space-between;
}
header .navbar .nav {
  display: flex;
  column-gap: 60px;
  align-items: flex-start;
}
header .navbar .nav .nav-item {
  padding-bottom: 5px;
  color: white;
}
header .navbar .nav .nav-item.active {
  color: #f6fe01;
  border-bottom: #f6fe01 solid 1px;
}

#navbar {
  transition: 0.7s;
}

header {
  padding-top: 30px;
  padding-bottom: 15px;
}
@media (max-width: 767px) {
  header {
    position: fixed;
    transition: top 0.6s ease-in-out;
    left: 0;
    right: 0;
    z-index: 5000;
    z-index: 5000;
    padding-top: 15px;
    padding-bottom: 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  header {
    padding-top: 15px;
    padding-bottom: 10px;
  }
}
header .header-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
header .header-main a {
  display: inline-block;
  font: 18px "Roboto Mono Regular";
  color: white;
  display: block;
  border-bottom: 1px solid transparent;
  display: inline-block;
}
header .header-main a #logo-brand {
  transition: 0.6s;
  font-size: 26px;
  line-height: 1.2;
}
header .header-main a img {
  display: inline-block;
  width: 80px;
}
@media (max-width: 767px) {
  header .header-main a img {
    width: 60px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  header .header-main a img {
    width: 61px;
  }
}
@media (max-width: 767px) {
  header .header-main a {
    font-size: 20px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  header .header-main a {
    font-size: 24px;
  }
}
header .header-main .brand {
  font-size: 26px;
  line-height: 1.2;
}
@media (max-width: 767px) {
  header .header-main .brand {
    font-size: 22px;
  }
}
header .header-main .nav-menu {
  display: flex;
  gap: 2.5rem;
}
@media (max-width: 767px) {
  header .header-main .nav-menu {
    padding-top: 80px;
    z-index: -1;
    position: fixed;
    left: -100%;
    top: 70px;
    gap: 0;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
    text-align: center;
    transition: 0.3s;
    overflow: hidden;
    background-color: #3b20e2;
  }
  header .header-main .nav-menu.active {
    left: 0;
  }
  header .header-main .nav-menu .nav-item {
    margin: 16px 0;
  }
}
@media (max-width: 767px) and (max-width: 767px) {
  header .header-main .nav-menu .nav-item {
    margin: 10px 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  header .header-main .nav-menu {
    position: fixed;
    left: -100%;
    top: 100px;
    gap: 0;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
    text-align: center;
    transition: 0.3s;
    background-color: #3b20e2;
  }
  header .header-main .nav-menu.active {
    left: 0;
    padding-top: 3rem;
  }
  header .header-main .nav-menu .nav-item {
    margin: 10px 0;
  }
}
header .header-main .nav-item:hover {
  color: #f6fe01;
}
header .header-main .nav-item.active {
  color: #f6fe01;
  border-bottom: 1px solid #f6fe01;
  padding-bottom: 10px;
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  header .header-main .nav-item {
    line-height: 2;
  }
}
header .header-main .nav-item .nav-link {
  display: inline-block;
  position: relative;
}
header .header-main .nav-item .nav-link:after {
  content: "";
  position: absolute;
  width: 100%;
  transform: scaleX(0);
  height: 2px;
  bottom: -18px;
  left: 0;
  background-color: white;
  transform-origin: bottom right;
  transition: transform 0.25s ease-out;
}
header .header-main .nav-item .nav-link:hover::after {
  transform: scaleX(1);
  transform-origin: bottom left;
}
header .header-main .hamburger {
  display: none;
  cursor: pointer;
}
header .header-main .hamburger .bar {
  display: block;
  width: 25px;
  height: 3px;
  margin: 5px auto;
  transition: all 0.3s ease-in-out;
  background-color: white;
}
header .header-main .hamburger .bar:nth-child(1) {
  opacity: 0;
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  header .header-main .hamburger .bar {
    width: 35px;
  }
}
@media (max-width: 767px) {
  header .header-main .hamburger {
    display: block;
  }
  header .header-main .hamburger.active .bar:nth-child(1) {
    opacity: 1;
    transform: translate(0px, 8px) rotate(45deg);
  }
  header .header-main .hamburger.active .bar:nth-child(2) {
    opacity: 0;
  }
  header .header-main .hamburger.active .bar:nth-child(3) {
    transform: translate(0px, -8px) rotate(-45deg);
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  header .header-main .hamburger {
    display: block;
  }
  header .header-main .hamburger.active .bar:nth-child(1) {
    opacity: 1;
    transform: translate(0px, 8px) rotate(45deg);
  }
  header .header-main .hamburger.active .bar:nth-child(2) {
    opacity: 0;
  }
  header .header-main .hamburger.active .bar:nth-child(3) {
    transform: translate(0px, -8px) rotate(-45deg);
  }
}

.banner {
  background-color: #3b20e2;
}
.banner .wrapper {
  display: flex;
  justify-content: center;
  padding-top: 60px;
  padding-bottom: 60px;
  gap: 4rem;
}
@media (max-width: 767px) {
  .banner .wrapper {
    gap: 2rem;
    padding-top: 40px;
    padding-bottom: 40px;
    flex-direction: column;
  }
}
.banner .wrapper.flex-donate {
  gap: 0;
}
@media (max-width: 767px) {
  .banner .wrapper.flex-donate {
    gap: 2rem;
  }
}
.banner .wrapper .flex-home {
  flex: 3 1;
}
.banner .wrapper .flex-home h1 {
  font-family: "Roboto Mono Regular";
  font-size: 60px;
  line-height: 1.1;
  font-weight: 700;
  text-transform: capitalize;
  color: white;
  display: inline;
}
@media (max-width: 767px) {
  .banner .wrapper .flex-home h1 {
    font-size: 22px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .banner .wrapper .flex-home h1 {
    font-size: 33px;
  }
}
.banner .wrapper .flex-home h2 {
  font-family: "Roboto Mono Regular";
  font-size: 60px;
  line-height: 1.1;
  font-weight: 700;
  text-transform: capitalize;
  color: white;
  background: #3b20e2;
  display: inline;
  line-height: 1.5;
}
.banner .wrapper .flex-home h3 {
  font-family: "Roboto Mono Regular";
  font-size: 60px;
  line-height: 1.1;
  font-weight: 700;
  text-transform: capitalize;
  color: white;
  background: #3b20e2;
  display: inline;
}
.banner .wrapper .flex-home p {
  margin-top: 2rem;
  font-family: "Roboto Mono Regular";
  color: white;
  font-size: 24px;
}
@media (max-width: 767px) {
  .banner .wrapper .flex-home p {
    max-width: 100%;
    font-size: 16px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .banner .wrapper .flex-home p {
    font-size: 16px;
  }
}
.banner .wrapper .flex-home a {
  margin-top: 2rem;
  display: inline-block;
  padding: 20px 40px;
  font-family: "Roboto Mono Regular";
  font-size: 24px;
  border: 2px white solid;
  border-radius: 10px;
  color: white;
  align-self: flex-start;
}
.banner .wrapper .flex-home a:hover {
  color: #3b20e2;
  background-color: white;
  border: 2px white solid;
  transition: 0.3s all ease-in-out;
}
@media (max-width: 767px) {
  .banner .wrapper .flex-home a {
    padding: 10px 20px;
    font-size: 18px;
    border: 1px white solid;
  }
}
@media (max-width: 767px) {
  .banner .wrapper .flex-home h2 {
    font-size: 36px;
  }
}
.banner .wrapper .flex-img {
  flex: 3 1;
}
.banner .wrapper .flex-img .donate-hero-img {
  width: 70%;
  margin-left: auto;
}
@media (max-width: 767px) {
  .banner .wrapper .flex-img .donate-hero-img {
    width: 70%;
    margin: auto;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .banner .wrapper .flex-img .donate-hero-img {
    width: 100%;
    margin: auto;
  }
}
@media only screen and (min-width: 1025px) {
  .banner {
    border-top: 15px solid #3b20e2;
    border-bottom: 15px solid #3b20e2;
  }
}
@media (max-width: 767px) {
  .banner {
    flex-direction: column;
  }
}

.about {
  background-color: #f5f5f5;
}
.about .wrapper {
  padding-top: 30px;
  padding-bottom: 30px;
}
@media (max-width: 767px) {
  .about .wrapper {
    padding-top: 40px;
  }
}
.about .wrapper .donate-copy-header {
  font-family: "Roboto Mono Regular";
  font-size: 30px;
  margin-bottom: 1rem;
  color: #3b20e2;
  line-height: 1.5;
  font-weight: 600;
}
@media (max-width: 767px) {
  .about .wrapper .donate-copy-header {
    font-size: 25px;
  }
}
.about .wrapper h2 {
  font-family: "Roboto Mono Regular";
  font-size: 41px;
  margin-bottom: 1rem;
  color: white;
  line-height: 1.2;
}
@media (max-width: 767px) {
  .about .wrapper h2 {
    font-size: 25px;
  }
}
.about .wrapper h3 {
  font-family: "Roboto Mono Regular";
  font-size: 30px;
  margin-bottom: 1rem;
  color: #3b20e2;
  line-height: 1.5;
}
@media (max-width: 767px) {
  .about .wrapper h3 {
    font-size: 25px;
  }
}
.about .wrapper p {
  font-family: "Roboto Mono Regular";
  margin-bottom: 25px;
  line-height: 1.5;
}
@media (max-width: 767px) {
  .about .wrapper p {
    line-height: 1.4;
  }
}
.about .wrapper .column-wrap .column {
  padding: 50px;
  background-color: #3b20e2;
  color: white;
  border-radius: 10px;
}
@media (max-width: 767px) {
  .about .wrapper .column-wrap .column {
    padding: 35px 20px;
  }
}
.about .wrapper .column-wrap .column .copy-wrap-dl {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 250px;
  align-items: flex-start;
}
@media (max-width: 767px) {
  .about .wrapper .column-wrap .column .copy-wrap-dl {
    height: unset;
  }
}
.about .wrapper .column-wrap .column .copy-delegation {
  line-height: 1.4;
  font-weight: unset;
  margin-bottom: 40px;
  font-size: 16px;
}
@media (max-width: 767px) {
  .about .wrapper .column-wrap .column .copy-delegation {
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 16px;
  }
}
.about .wrapper .column-wrap .column a {
  display: inline-block;
  padding: 20px 40px;
  font-family: "Roboto Mono Regular";
  font-size: 24px;
  border: 2px white solid;
  border-radius: 10px;
}
.about .wrapper .column-wrap .column a:hover {
  color: #3b20e2;
  background-color: white;
  border: 2px white solid;
  transition: 0.3s all ease-in-out;
}
@media (max-width: 767px) {
  .about .wrapper .column-wrap .column a {
    padding: 10px 20px;
    font-size: 18px;
    border: 1px white solid;
  }
}
.about .wrapper .column-wrap .column.col-del {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat;
  background-position: 96% 4%;
}
@media (max-width: 767px) {
  .about .wrapper .column-wrap .column.col-del {
    background-size: 28%;
    background-position: 95% 4%;
  }
}
.about .wrapper .column-wrap .column.col-liq {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-position: 95% 10%;
  flex-direction: column;
  align-items: flex-start;
}
.about .wrapper .column-wrap .column.col-liq .copy-wrap-dl {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 250px;
  align-items: flex-start;
}
@media (max-width: 767px) {
  .about .wrapper .column-wrap .column.col-liq .copy-wrap-dl {
    height: unset;
  }
}
.about .wrapper .column-wrap .column.col-liq p {
  font-size: 16px;
  font-weight: 400;
}
@media (max-width: 767px) {
  .about .wrapper .column-wrap .column.col-liq p {
    font-size: 16px;
  }
}
@media (max-width: 767px) {
  .about .wrapper .column-wrap .column.col-liq {
    background-size: 28%;
  }
}
.about .wrapper .column-wrap.column-wrap-2 {
  margin-top: 30px;
}
.about .wrapper .column-wrap.column-wrap-2 .col-del {
  flex: 1 1;
}
.about .wrapper .column-wrap.column-wrap-2 .col-del .copy-wrap-dl {
  height: unset;
}
@media (max-width: 767px) {
  .about .wrapper .column-wrap-page {
    padding-bottom: 0px;
  }
}
.about .wrapper .column-wrap-page p {
  font-family: "Roboto Mono Regular";
  font-size: 15px;
  line-height: 1.5;
}
.about .wrapper .column-wrap-page p .link-a {
  color: #3b20e2;
  font-weight: 700;
}
.about .wrapper .column-wrap-page p .link-a:hover {
  color: #08d0ae;
  transition: all 0.2s ease-in-out;
}
.about .wrapper .column-wrap-page .page-btn {
  margin-top: 55px;
}
@media (max-width: 767px) {
  .about .wrapper .column-wrap-page .page-btn {
    margin-top: 30px;
  }
}
.about .wrapper .column-wrap-page .page-btn a {
  display: table;
  font-family: "Roboto Mono Regular";
  padding: 20px 40px;
  font-size: 24px;
  border: 2px #3b20e2 solid;
  border-radius: 10px;
  background-color: transparent;
  color: #3b20e2;
  margin-bottom: 18px;
}
.about .wrapper .column-wrap-page .page-btn a:hover {
  color: white;
  background-color: #3b20e2;
  border: 2px #3b20e2 solid;
  transition: 0.3s all ease-in-out;
}
@media (max-width: 767px) {
  .about .wrapper .column-wrap-page .page-btn a {
    padding: 10px 20px;
    font-size: 18px;
    border: 1px #3b20e2 solid;
  }
}
.about .wrapper .donate {
  margin-top: 20px;
  background-color: white;
  border-radius: 8px;
  padding: 50px;
  flex-direction: column;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-position: 96% 10%;
}
@media (max-width: 767px) {
  .about .wrapper .donate {
    padding: 35px 20px;
    background-size: 45%;
    background-position: 95% 10%;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .about .wrapper .donate {
    background-size: 50%;
  }
}
.about .wrapper .donate h2 {
  color: #3b20e2;
  font-family: "Roboto Mono Regular";
  font-size: 41px;
}
@media (max-width: 767px) {
  .about .wrapper .donate h2 {
    font-size: 32px;
    margin-bottom: 15px;
  }
}
.about .wrapper .donate .copy-donate {
  color: #3b20e2;
  line-height: 1.4;
  font-weight: unset;
  max-width: 40%;
}
@media (max-width: 767px) {
  .about .wrapper .donate .copy-donate {
    max-width: 100%;
  }
}
.about .wrapper .donate a {
  display: table;
  padding: 20px 40px;
  font-family: "Roboto Mono Regular";
  font-size: 24px;
  border: 2px #3b20e2 solid;
  border-radius: 10px;
  background-color: white;
  color: #3b20e2;
}
.about .wrapper .donate a:hover {
  color: white;
  background-color: #3b20e2;
  border: 2px #3b20e2 solid;
  transition: 0.3s all ease-in-out;
}
@media (max-width: 767px) {
  .about .wrapper .donate a {
    padding: 12px 22px;
    font-size: 18px;
  }
}

.description .wrapper {
  padding-top: 30px;
  padding-bottom: 30px;
}
.description .wrapper .title h2 {
  font-family: "Roboto Mono Regular";
  font-size: 30px;
  margin-bottom: 1rem;
  color: #3b20e2;
  line-height: 1.5;
}
@media (max-width: 767px) {
  .description .wrapper .title h2 {
    font-size: 25px;
  }
}
.description .wrapper .title p {
  font-family: "Roboto Mono Regular";
  margin-bottom: 1rem;
  line-height: 1.5;
}
.description .wrapper .copy h2 {
  padding-top: 5px;
  font-family: "Roboto Mono Regular";
  margin-bottom: 0.5rem;
  font-weight: 700;
  color: #3b20e2;
  line-height: 1.5;
}
.description .wrapper .copy p {
  font-family: "Roboto Mono Regular";
  margin-bottom: 1rem;
  line-height: 1.5;
}

footer {
  background-color: #000;
  color: white;
}

.grey {
  background-color: #f5f5f5;
}

hr {
  border: 1px solid #c3bfbf;
}

.about1 .wrapper {
  padding-top: 30px;
  padding-bottom: 30px;
}
.about1 .wrapper h2 {
  font-family: "Roboto Mono Regular";
  font-size: 30px;
  margin-bottom: 1rem;
  color: #3b20e2;
  line-height: 1.5;
}
@media (max-width: 767px) {
  .about1 .wrapper h2 {
    font-size: 25px;
  }
}
.about1 .wrapper p {
  font-family: "Roboto Mono Regular";
  margin-bottom: 1rem;
  line-height: 1.5;
}

.column-wrap {
  display: flex;
}
@media only screen and (min-width: 1025px) {
  .column-wrap {
    gap: 20px;
  }
  .column-wrap .column {
    flex-basis: 50%;
  }
}
@media (max-width: 767px) {
  .column-wrap {
    flex-direction: column;
    row-gap: 20px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .column-wrap {
    flex-direction: column;
    row-gap: 20px;
  }
}

footer {
  padding-top: 50px;
  padding-bottom: 50px;
}
@media (max-width: 767px) {
  footer {
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
footer .wrapper {
  display: flex;
  justify-content: space-between;
}
@media (max-width: 767px) {
  footer .wrapper {
    flex-direction: column;
    row-gap: 20px;
  }
}
footer .wrapper .col .logo {
  line-height: 1.2;
  font-family: "Roboto Mono Regular";
  font-weight: 700;
  font-size: 24px;
}
footer .wrapper .col .head {
  font-family: "Roboto Mono Regular";
  font-weight: 700;
  font-size: 24px;
  margin-bottom: 10px;
  color: #807f80;
}
@media (max-width: 767px) {
  footer .wrapper .col .head {
    margin-bottom: 5px;
    font-size: 20px;
  }
}
footer .wrapper .col a {
  font-family: "Roboto Mono Regular";
  line-height: 1.9;
}
@media (max-width: 767px) {
  footer .wrapper .col a {
    line-height: 1.4;
  }
}
footer .wrapper .col .brand img {
  width: 90px;
}
@media (max-width: 767px) {
  footer .wrapper .col .brand img {
    width: 75px;
  }
}

/* MODAL */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.modal-close-button {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 18px;
  width: 22px;
  height: 22px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  background: #efefef;
  border-radius: 50%;
  color: gray;
}
.modal-close-button span {
  font-size: 26px;
}
.modal-close-button:hover {
  color: black;
}

.qr-code {
  max-width: 320px;
  margin: 0 auto;
}

.container a {
  word-wrap: break-word;
}

.qr-wallet {
  text-align: center;
}
.qr-wallet .wallet-tc {
  font-size: 10px;
  margin-bottom: 0px !important;
}
.qr-wallet .wallet-tc .hover-tc:hover {
  text-decoration: underline;
}
.qr-wallet .wallet-address {
  margin-bottom: 10px !important;
}
.qr-wallet h4 {
  font-size: 22px;
  margin-bottom: 20px;
  font-family: "Roboto Mono Regular";
}
.qr-wallet .qr-wrap {
  margin-bottom: 20px;
}
@media (max-width: 767px) {
  .qr-wallet .wallet-address {
    font-size: 11px;
  }
}

.form-container {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin: 0 auto;
  max-width: 70%;
}
@media (max-width: 767px) {
  .form-container {
    max-width: 100%;
  }
}

.form-input {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 3px;
  margin-bottom: 10px;
  font-family: "Roboto Mono Regular";
  width: 100%;
  color: rgb(5, 5, 5);
}

.div-form {
  width: 45%;
  margin-bottom: 10px;
}
@media (max-width: 767px) {
  .div-form {
    width: 100%;
  }
}

.class-checkbox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.wallet-ad {
  width: 70%;
}

.div-tick {
  display: flex;
}

.checkbox-group {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  width: 80%;
  justify-content: center;
}
@media (max-width: 767px) {
  .checkbox-group {
    width: 100%;
  }
}

.checkbox-group label {
  margin-left: 5px;
  font-family: "Roboto Mono Regular";
  margin-bottom: 10px;
}

.submit-btn {
  width: 60%;
  display: table;
  padding: 10px 30px;
  font-family: "Roboto Mono Regular";
  font-size: 16px;
  border: 2px #3b20e2 solid;
  border-radius: 10px;
  background-color: white;
  text-align: center;
  color: #3b20e2 !important;
}
.submit-btn:hover {
  color: white !important;
  background-color: #3b20e2;
  border: 2px #3b20e2 solid;
  transition: 0.3s all ease-in-out;
}
@media (max-width: 767px) {
  .submit-btn {
    padding: 12px 22px;
    font-size: 18px;
  }
}

input[type=checkbox] {
  display: none;
}

/* Style the custom tick */
.custom-tick {
  display: inline-block;
  width: 20fpx;
  height: 16px;
  border: 1px solid #ccc;
  border-radius: 3px;
  margin-right: 8px;
}

.custom-tick svg {
  display: block;
  width: 100%;
  height: 100%;
}

.error {
  color: red;
  font-family: "Roboto Mono Regular";
  font-size: 12px;
}

/* styles.css (or any other CSS file) */
/* styles.css (or any other CSS file) */
.form-checkbox {
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
}

.form-checkbox input {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}

.form-checkbox .checkmark {
  position: absolute;
  left: 0;
  top: 0;
  width: 20px;
  height: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.form-checkbox .checkmark::after {
  content: "";
  position: absolute;
  display: none;
}

.form-checkbox input:checked + .checkmark::after {
  display: block;
  content: "✓"; /* Checkmark Unicode character */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right;
  background-size: contain;
  text-align: center;
  line-height: 20px;
  font-size: 24px;
  color: transparent;
}

.form-checkbox input:required:not(:checked) + .checkmark {
  border-color: rgb(76, 0, 255);
}

.custom-checkbox {
  position: relative;
  padding-left: 25px; /* Space for the custom tick */
  cursor: pointer;
}

/* Styling the custom tick */
.custom-checkbox .checkbox-tick {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #fff;
  border: 2px solid #333;
  border-radius: 3px;
}

/* Styling the custom tick when the checkbox is checked */
.custom-checkbox .checkbox-tick::after {
  content: "";
  position: absolute;
  display: none;
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid #007bff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

/* Show the custom tick when the checkbox is checked */
.custom-checkbox input:checked + .checkbox-tick::after {
  display: block;
}

/* Hide the default checkbox */
.custom-checkbox input {
  display: none;
}

.terms-c {
  max-width: 60%;
  margin: auto;
}
@media (max-width: 767px) {
  .terms-c {
    max-width: 100%;
  }
}
.terms-c h2 {
  font-family: "Roboto Mono Regular";
  font-size: 30px;
  margin-bottom: 1rem;
  margin-top: 1rem;
  color: #3b20e2;
  line-height: 1.5;
  text-align: center;
}
@media (max-width: 767px) {
  .terms-c h2 {
    font-size: 20px;
  }
}
.terms-c ul {
  list-style: auto;
}
@media (max-width: 767px) {
  .terms-c ul {
    padding-left: 30px;
  }
}
.terms-c ul li {
  margin-bottom: 20px;
  font-family: "Roboto Mono Regular";
  line-height: 1.6;
}
@media (max-width: 767px) {
  .terms-c ul li {
    font-size: 14px;
  }
}

/* Add your other styles... */
.options button {
  margin: 15px;
  padding: 18px 16px;
  border: none;
  cursor: pointer;
}
.options button .wrapper-icon {
  display: flex;
  align-items: center;
  width: 25px;
  height: 25px;
  margin: auto;
}
.options button .credit-card {
  margin: auto;
}
.options button .crypto-card {
  width: 16px;
  margin: auto;
}
@media (max-width: 767px) {
  .options button .crypto-card {
    width: 13px;
  }
}

.options button.selected {
  background-color: #3b20e2;
  color: white !important;
}

.pay-now-btn {
  padding: 10px 20px;
  background-color: #2ecc71;
  border: none;
  color: white;
  cursor: pointer;
}

.pay-now-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.amount-input {
  margin: 10px 0;
  color: black;
}
.amount-input label {
  display: block;
  margin-bottom: 5px;
}
@media (max-width: 767px) {
  .amount-input label {
    font-size: 14px;
    line-height: 1.4;
  }
}

.amount-input input {
  width: 100%;
  padding: 8px;
}

/* Add your other styles... */
.modal-content {
  background-color: white;
  padding: 30px 0;
  border-radius: 8px;
  text-align: center;
  font-family: "Roboto Mono Regular";
  max-width: 900px;
}
.modal-content .copy-head {
  margin-bottom: 40px;
  color: #3b20e2;
  text-align: center;
  font-family: "Roboto Mono Regular";
  font-weight: 700;
  font-size: 19px;
}
@media (max-width: 767px) {
  .modal-content .copy-head {
    margin-bottom: 30px;
    padding: 0 30px;
    font-size: 15px;
  }
}
@media (max-width: 767px) {
  .modal-content {
    width: 90%;
    padding-top: 25px;
    margin: auto;
  }
}
.modal-content h2 {
  color: #3b20e2;
  font-size: 20px;
  text-align: start;
  margin-bottom: 20px;
}
.modal-content p {
  color: black;
  text-align: left;
}
.amount-input {
  display: flex;
  align-items: center;
  margin: 10px 0;
  text-align: left;
  font-family: "Roboto Mono Regular";
  border-bottom: 1px solid #d7d7d7;
}
@media (max-width: 767px) {
  .amount-input {
    margin-bottom: 10px;
  }
}

.amount-input label {
  font-family: "Roboto Mono Regular";
  font-weight: bold;
}

.amount-input input {
  flex: 1 1;
  margin-left: 5px;
  padding: 8px;
  border: 1px solid #3b20e2;
  border-radius: 4px;
  max-width: 200px;
}

input[type=text]:focus {
  border: 2px solid #3b20e2;
}

::placeholder {
  font-family: "Roboto Mono Regular";
}

.total-amount {
  font-weight: bold;
  color: black;
  font-family: "Roboto Mono Regular";
  border-top: 1px solid #ccc;
  padding-top: 25px;
  margin-bottom: 25px;
}
.options {
  border-radius: 5px;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-bottom: 10px;
  font-family: "Roboto Mono Regular";
}
@media (max-width: 767px) {
  .options {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
.options p {
  text-align: center;
  margin-bottom: 20px;
  font-size: 16px;
  color: black;
}
.options .payment-div {
  display: flex;
  gap: 2rem;
  justify-content: center;
  align-items: center;
}
.options .payment-div .or-name {
  font-size: 1.2rem;
  font-family: "Roboto Mono Regular";
  text-transform: uppercase;
}
.options .payment-div .white-color {
  color: #3b20e2;
}
.options .payment-div p {
  font-size: 15px;
}

.options button {
  margin: 10px;
  padding: 20px 21px;
  border: none;
  cursor: pointer;
  font-family: "Roboto Mono Regular";
  color: #3b20e2;
  border-radius: 50%;
  border: 1px solid #3b20e2;
}
@media (max-width: 767px) {
  .options button {
    padding: 13px 14px;
  }
}

.options button.selected {
  color: white;
  border-radius: 50%;
}

.pay-now-btn {
  display: table;
  padding: 12px 42px;
  font-family: "Roboto Mono Regular";
  font-size: 26px;
  border: 2px #3b20e2 solid;
  border-radius: 5px;
  background-color: white;
  color: #3b20e2;
  margin: auto;
  margin-bottom: 15px;
}
.pay-now-btn:hover {
  color: white;
  background-color: #3b20e2;
  border: 2px #3b20e2 solid;
  transition: 0.3s all ease-in-out;
}
@media (max-width: 767px) {
  .pay-now-btn {
    padding: 10px 22px;
    font-size: 21px;
  }
}

.pay-now-btn:disabled {
  background-color: white;
  color: #3b20e2;
  cursor: not-allowed;
}

.input-wrapper {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  row-gap: 5px;
  position: relative;
}
.input-wrapper .error-message-0 {
  color: red !important;
  font-size: 9px;
  position: absolute;
  left: 5px;
  /* top: 0%; */
  bottom: -54%;
  width: 123%;
}
@media (max-width: 767px) {
  .input-wrapper .error-message-0 {
    position: absolute;
    left: 7px;
    /* top: 0%; */
    bottom: -42%;
  }
}

.error-message-1 {
  color: red !important;
  position: absolute !important;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 9px !important;
}
@media (max-width: 767px) {
  .error-message-1 {
    width: 100%;
  }
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  outline: none;
  color: #3b20e2 !important;
}
@media (max-width: 767px) {
  .close-btn {
    top: 5px;
    right: 5px;
  }
}

.main-div {
  position: relative;
}
.main-div .banner {
  padding-bottom: 9rem;
}
@media (max-width: 767px) {
  .main-div .banner {
    padding-bottom: 9rem;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .main-div .banner {
    padding-bottom: 11rem;
  }
}
.main-div .about {
  padding-top: 15rem;
}
@media (max-width: 767px) {
  .main-div .about {
    padding-top: 15rem;
  }
}
.main-div .donate-page-form {
  max-width: 900px;
  position: absolute;
  top: 0;
  position: absolute;
  top: 58%; /* position the top  edge of the element at the middle of the parent */
  left: 50%; /* position the left edge of the element at the middle of the parent */
  transform: translate(-50%, -57%);
  width: 80%;
}
@media (max-width: 767px) {
  .main-div .donate-page-form {
    top: 50%; /* position the top  edge of the element at the middle of the parent */
    left: 50%; /* position the left edge of the element at the middle of the parent */
    width: 100%;
    transform: translate(-50%, -50%);
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .main-div .donate-page-form {
    top: 60%;
  }
}

.server-program .container {
  width: 90%;
}
.server-program .faq {
  background-color: #f5f5f5;
  padding-top: 50px;
  padding-bottom: 50px;
}
.server-program .faq .about-wrapper {
  border-radius: 20px;
  padding: 3rem;
  background-color: #3b20e2;
  display: flex;
  align-items: flex-start;
}
@media (max-width: 767px) {
  .server-program .faq .about-wrapper {
    padding: 2rem;
    flex-direction: column;
  }
}
.server-program .faq .about-wrapper .about-head {
  flex: 1 1;
  font-size: 30px;
  color: white;
  font-family: "Roboto Mono Regular";
}
@media (max-width: 767px) {
  .server-program .faq .about-wrapper .about-head {
    font-size: 25px;
  }
}
.server-program .faq .about-wrapper .about-copy {
  flex: 2 1;
}
.server-program .faq .about-wrapper .about-copy .copy {
  color: white;
  font-family: "Roboto Mono Regular";
  font-size: 15px;
  margin-top: 10px;
  margin-bottom: 30px;
  line-height: 1.5;
}
.server-program .faq .about-wrapper .about-copy .copy:last-child {
  margin-bottom: unset;
}
.server-program .faq .faq-wrapper {
  padding: 3rem;
  margin-top: 50px;
  border-radius: 20px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background-color: white;
}
@media (max-width: 767px) {
  .server-program .faq .faq-wrapper {
    flex-direction: column;
    padding: 2rem;
    margin-top: 30px;
  }
}
.server-program .faq .faq-wrapper .faq-head {
  font-family: "Roboto Mono Regular";
  font-size: 30px;
  color: #3b20e2;
  flex: 1 1;
}
@media (max-width: 767px) {
  .server-program .faq .faq-wrapper .faq-head {
    font-size: 25px;
  }
}
.server-program .faq .faq-wrapper .faq-item {
  flex: 2 1;
}
.server-program .faq .faq-wrapper .faq-item .faq-copy-wrapper .qt-ans {
  padding-right: 30px;
  font-family: "Roboto Mono Regular";
  margin-bottom: 30px;
}
@media (max-width: 767px) {
  .server-program .faq .faq-wrapper .faq-item .faq-copy-wrapper .qt-ans {
    padding-right: 0px;
  }
}
@media (max-width: 767px) {
  .server-program .faq .faq-wrapper .faq-item .faq-copy-wrapper .qt-ans:last-child {
    margin-bottom: 10px;
  }
}
.server-program .faq .faq-wrapper .faq-item .faq-copy-wrapper .qt-ans .qt {
  color: #3b20e2;
  font-weight: 700;
  font-size: 18px;
  line-height: 1.5;
  margin-bottom: 8px;
}
@media (max-width: 767px) {
  .server-program .faq .faq-wrapper .faq-item .faq-copy-wrapper .qt-ans .qt {
    font-size: 15px;
    margin-top: 20px;
  }
}
.server-program .faq .faq-wrapper .faq-item .faq-copy-wrapper .qt-ans .ans {
  font-size: 16px;
  line-height: 1.5;
}
@media (max-width: 767px) {
  .server-program .faq .faq-wrapper .faq-item .faq-copy-wrapper .qt-ans .ans {
    font-size: 14px;
  }
}
.server-program .faq .faq-wrapper .faq-item .faq-copy-wrapper .qt-ans .ans .link-a {
  color: #3b20e2;
  font-weight: 700;
}
.server-program .faq .faq-wrapper .faq-item .faq-copy-wrapper .qt-ans .ans .link-a:hover {
  color: #08d0ae;
  transition: all 0.2s ease-in-out;
}
.server-program .faq .faq-wrapper .faq-item .accordion-wrapper {
  margin-bottom: 30px;
}
.server-program .faq .faq-wrapper .faq-item .accordion-wrapper .accordion-item {
  margin-bottom: 10px;
}
.server-program .faq .faq-wrapper .faq-item .accordion-wrapper .accordion-item .accordion-title {
  background-color: #3b20e2;
  padding: 10px;
  cursor: pointer;
  border: none;
  width: 100%;
  text-align: left;
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  color: white;
  font-family: "Roboto Mono Regular";
  border-radius: 10px;
  font-size: 20px;
}
@media (max-width: 767px) {
  .server-program .faq .faq-wrapper .faq-item .accordion-wrapper .accordion-item .accordion-title {
    font-size: 15px;
  }
}
.server-program .faq .faq-wrapper .faq-item .accordion-wrapper .accordion-item .accordion-content {
  padding: 10px;
  background-color: #fafafa;
  font-family: "Roboto Mono Regular";
  font-size: 16px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}
@media (max-width: 767px) {
  .server-program .faq .faq-wrapper .faq-item .accordion-wrapper .accordion-item .accordion-content {
    font-size: 14px;
  }
}
.server-program .faq .faq-wrapper .faq-item .faq-acc-ans .flex-class {
  display: flex;
  margin-bottom: 5px;
}
.server-program .faq .faq-wrapper .faq-item .faq-acc-ans .flex-class .flex-item {
  flex: 1 1;
}
.server-program .faq .faq-wrapper .faq-item .faq-acc-ans .flex-class .flex-item1 {
  flex: 2 1;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/main.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,6BAAA;EACA,oHAAA;EAEA,mBAAA;EACA,kBAAA;EACA,kBAAA;AACF;AAEA;EACE,kCAAA;EACA,oHAAA;EAEA,mBAAA;EACA,kBAAA;EACA,kBAAA;AADF;AAIA;EACE,yBAAA;EACA,oHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAHF;AAMA,cAAA;AAOA,WAAA;AAsDA,cAAA;AAEA;;;OAAA;AAKA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFE,cAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;AAjEF;;AAmEA,gDAAA;AACA;;;;;;;;;;;EAWE,cAAA;AAhEF;;AAkEA;EACE,cAAA;AA/DF;;AAiEA;;EAEE,gBAAA;AA9DF;;AAgEA;;EAEE,YAAA;AA7DF;;AA+DA;;;;EAIE,WAAA;EACA,aAAA;AA5DF;;AA8DA;EACE,yBAAA;EACA,iBAAA;AA3DF;;AA8DA;EACE,sBAAA;AA3DF;;AA8DA;EASE,qBAAA;AAnEF;AA2DE;EAKE,cAAA;AA7DJ;;AAmEA;;;EAGE,kBAAA;AAhEF;;AAwEA;EACE,WAAA;AArEF;;AAuEA;EACE,YAAA;AApEF;;AAuEA;EACE,WAAA;EACA,cAAA;EACA,WAAA;AApEF;;AAsEA;EACE,OAAA;EACA,cAAA;EACA,WAAA;AAnEF;AAqEE;EAEE,WAAA;EACA,cAAA;AApEJ;AAuEE;EACE,WAAA;AArEJ;;AAyEA;EACE,aAAA;AAtEF;;AAyEA;;;EAGE,gBAAA;EACA,gBAAA;AAtEF;;AAyEA;EACE,gBAAA;AAtEF;;AAyEA;EACE,YAAA;AAtEF;;AAyEA,YAAA;AAEA;EACE,mCAAA;EACA,qBAAA;AAvEF;;AA0EA;;EAEE,WAAA;AAvEF;;AA0EA;;;;EAIE,wBAAA;EACA,aAAA;EACA,gBAAA;EACA,6BAAA;AAvEF;;AA0EA;;EAEE,uBAAA;EACA,YAAA;AAvEF;;AA0EA;;;;;EAKE,aAAA;AAvEF;;AA0EA;EACE,cAAA;EACA,eAAA;AAvEF;;AA0EA;;;;;;;;EAQE,gBAAA;AAvEF;;AA0EA;EACE,gBAAA;AAvEF;;AAyEA;EACE,cAAA;EACA,eAAA;EACA,YAAA;AAtEF;;AAyEA,gCAAA;AACA;;EAEE,wBAAA;EACA,SAAA;AAtEF;;AAyEA,YAAA;AACA;EACE,0BAAA;AAtEF;;AAyEA;;EAEE,WAAA;AAtEF;;AAyEA;EACE,YAAA;EACA,kBAAA;AAtEF;AA6EA;EACE,eAAA;AA3EF;;AA8EA;EACE,4BAAA;EACA,sBAAA;AA3EF;;AA6EA;EACE,uBAAA;AA1EF;;AA3QI;EAwVJ;IAEI,wBAAA;EA1EF;AACF;;AAzRI;EAqWJ;IAEI,wBAAA;EAzEF;AACF;;AA3RI;EAsWJ;IAEI,wBAAA;EAxEF;AACF;;AA2EA;EACE,WAAA;EACA,YAAA;AAxEF;;AA2EA;EACE,iBAAA;EACA,cAAA;EACA,UAAA;AAxEF;AA5SI;EAiXJ;IAMI,UAAA;IACA,gBAAA;IACA,cAAA;EAvEF;AACF;AAvTI;EAqXJ;IAWI,WAAA;IACA,eAAA;IACA,cAAA;EArEF;AACF;;AAwEA;EACE,2BAAA;EACA,4BAAA;AArEF;;AAwEA;EACE,eAAA;AArEF;AAvUI;EA2YJ;IAGI,eAAA;EAnEF;AACF;;AAsEA;EACE,gBAAA;AAnEF;;AAhVI;EAqZJ;IAEI,iBAAA;EAlEF;AACF;;AAoEA;EACE,yBAAA;AAjEF;AAkEE;EACE,YAAA;EACA,kCA1aM;EA2aN,eAAA;EACA,gBAAA;AAhEJ;AAkEE;EACE,YAAA;EACA,kCAhbM;EAibN,qBAAA;EACA,eAAA;EACA,gBAAA;AAhEJ;AAkEE;EACE,iBAAA;EACA,oBAAA;EAxZF,aAAA;EA0ZE,8BAAA;AA5DJ;AA6DI;EACE,aAAA;EACA,gBAAA;EACA,uBAAA;AA3DN;AA4DM;EACE,mBAAA;EACA,YAAA;AA1DR;AA2DQ;EACE,cAAA;EACA,gCAAA;AAzDV;;AA+DA;EACE,gBAAA;AA5DF;;AA8DA;EACE,iBAAA;EACA,oBAAA;AA3DF;AAvYI;EAgcJ;IAII,eAAA;IACA,gCAAA;IACA,OAAA;IACA,QAAA;IACA,aAAA;IACA,aAAA;IACA,iBAAA;IACA,oBAAA;EAzDF;AACF;AA/YI;EA4bJ;IAcI,iBAAA;IACA,oBAAA;EAvDF;AACF;AAwDE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAtDJ;AAwDI;EACE,qBAAA;EACA,gCAAA;EACA,YAAA;EACA,cAAA;EACA,oCAAA;EAgBA,qBAAA;AArEN;AAsDM;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;AApDR;AAsDM;EACE,qBAAA;EACA,WAAA;AApDR;AA/aI;EAieE;IAII,WAAA;EAlDR;AACF;AAhbI;EA6dE;IAOI,WAAA;EAhDR;AACF;AAzbI;EAsdA;IAuBI,eAAA;EAhDN;AACF;AA1bI;EAkdA;IA0BI,eAAA;EA9CN;AACF;AAiDI;EACE,eAAA;EACA,gBAAA;AA/CN;AAvcI;EAofA;IAII,eAAA;EA7CN;AACF;AA+CI;EACE,aAAA;EACA,WAAA;AA7CN;AAhdI;EA2fA;IAII,iBAAA;IACA,WAAA;IACA,eAAA;IACA,WAAA;IACA,SAAA;IACA,MAAA;IACA,sBAAA;IACA,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,gBAAA;IACA,yBArhBD;EA0eL;EA6CM;IACE,OAAA;EA3CR;EAgDM;IACE,cAAA;EA9CR;AACF;AAveI;EAmhBI;IAGI,cAAA;EA3CV;AACF;AAxeI;EAufA;IAiCI,eAAA;IACA,WAAA;IACA,UAAA;IACA,MAAA;IACA,sBAAA;IACA,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,yBA/iBD;EAmgBL;EA6CM;IACE,OAAA;IACA,iBAAA;EA3CR;EA6CM;IACE,cAAA;EA3CR;AACF;AA+CM;EACE,cAAA;AA7CR;AA+CM;EACE,cAAA;EACA,gCAAA;EACA,oBAAA;AA7CR;AArgBI;EA2iBA;IAUI,cAAA;EA5CN;AACF;AA6CM;EACE,qBAAA;EACA,kBAAA;AA3CR;AA4CQ;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,aAAA;EACA,OAAA;EACA,uBAAA;EACA,8BAAA;EACA,oCAAA;AA1CV;AA4CQ;EACE,oBAAA;EACA,6BAAA;AA1CV;AA+CI;EACE,aAAA;EACA,eAAA;AA7CN;AA8CM;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,gCAAA;EACA,uBAAA;AA5CR;AA6CQ;EACE,UAAA;AA3CV;AA7iBI;EAglBE;IAWI,WAAA;EA1CR;AACF;AAtjBI;EAilBA;IAkBI,cAAA;EAzCN;EA2CM;IACE,UAAA;IACA,4CAAA;EAzCR;EA2CM;IACE,UAAA;EAzCR;EA2CM;IACE,8CAAA;EAzCR;AACF;AAjkBI;EA6kBA;IAgCI,cAAA;EAxCN;EA0CM;IACE,UAAA;IACA,4CAAA;EAxCR;EA0CM;IACE,UAAA;EAxCR;EA0CM;IACE,8CAAA;EAxCR;AACF;;AA8CA;EACE,yBA7oBK;AAkmBP;AA6CE;EACE,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,SAAA;AA3CJ;AA/lBI;EAqoBF;IAQI,SAAA;IACA,iBAAA;IACA,oBAAA;IACA,sBAAA;EA1CJ;AACF;AA4CI;EACE,MAAA;AA1CN;AA1mBI;EAmpBA;IAGI,SAAA;EAxCN;AACF;AA2CI;EACE,SAAA;AAzCN;AA2CM;EACE,kCA1qBE;EA2qBF,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,YAAA;EACA,eAAA;AAzCR;AA3nBI;EA6pBE;IAUI,eAAA;EAxCR;AACF;AA5nBI;EAypBE;IAaI,eAAA;EAtCR;AACF;AAwCM;EACE,kCA1rBE;EA2rBF,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAtCR;AAwCM;EACE,kCArsBE;EAssBF,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AAtCR;AAwCM;EACE,gBAAA;EACA,kCAAA;EACA,YAAA;EACA,eAAA;AAtCR;AAhqBI;EAksBE;IAMI,eAAA;IACA,eAAA;EApCR;AACF;AAlqBI;EA8rBE;IAUI,eAAA;EAlCR;AACF;AAqCM;EACE,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kCAhuBE;EAiuBF,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;AAnCR;AAoCQ;EACE,cAruBH;EAsuBG,uBAAA;EACA,uBAAA;EACA,gCAAA;AAlCV;AA5rBI;EAgtBE;IAiBI,kBAAA;IACA,eAAA;IACA,uBAAA;EAjCR;AACF;AAnsBI;EAuuBI;IACE,eAAA;EAjCR;AACF;AAoCI;EACE,SAAA;AAlCN;AAmCM;EACE,UAAA;EACA,iBAAA;AAjCR;AA/sBI;EA8uBE;IAII,UAAA;IACA,YAAA;EA/BR;AACF;AAjtBI;EA0uBE;IAQI,WAAA;IACA,YAAA;EA7BR;AACF;AAntBI;EA0nBJ;IA2HI,8BAAA;IACA,iCAAA;EA9BF;AACF;AAjuBI;EAkoBJ;IA+HI,sBAAA;EA5BF;AACF;;AA8BA;EACE,yBAAA;AA3BF;AA4BE;EACE,iBAAA;EACA,oBAAA;AA1BJ;AA9uBI;EAswBF;IAII,iBAAA;EAxBJ;AACF;AAyBI;EACE,kCAzxBI;EA0xBJ,eAAA;EACA,mBAAA;EACA,cA1xBC;EA2xBD,gBAAA;EACA,gBAAA;AAvBN;AA3vBI;EA4wBA;IASI,eAAA;EAtBN;AACF;AAwBI;EACE,kCAryBI;EAsyBJ,eAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AAtBN;AAvwBI;EAwxBA;IAQI,eAAA;EArBN;AACF;AAuBI;EACE,kCAhzBI;EAizBJ,eAAA;EACA,mBAAA;EACA,cAjzBC;EAkzBD,gBAAA;AArBN;AAnxBI;EAmyBA;IAQI,eAAA;EApBN;AACF;AAuBI;EACE,kCA5zBI;EA6zBJ,mBAAA;EACA,gBAAA;AArBN;AA7xBI;EA+yBA;IAMI,gBAAA;EApBN;AACF;AAwBM;EACE,aAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;AAtBR;AAxyBI;EA0zBE;IAMI,kBAAA;EApBR;AACF;AAqBQ;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;AAnBV;AArzBI;EAk0BI;IAQI,aAAA;EAjBV;AACF;AAoBQ;EAEE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAnBV;AAh0BI;EA80BI;IAOI,gBAAA;IACA,mBAAA;IACA,eAAA;EAjBV;AACF;AAmBQ;EACE,qBAAA;EACA,kBAAA;EACA,kCAz2BA;EA02BA,eAAA;EACA,uBAAA;EACA,mBAAA;AAjBV;AAkBU;EACE,cA52BL;EA62BK,uBAAA;EACA,uBAAA;EACA,gCAAA;AAhBZ;AAr1BI;EA01BI;IAcI,kBAAA;IACA,eAAA;IACA,uBAAA;EAfV;AACF;AAkBQ;EACE,yDAAA;EACA,4BAAA;EACA,2BAAA;AAhBV;AAj2BI;EA82BI;IAKI,oBAAA;IACA,2BAAA;EAdV;AACF;AAgBQ;EACE,yDAAA;EACA,4BAAA;EACA,4BAAA;EAGA,sBAAA;EACA,uBAAA;AAhBV;AAiBU;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;AAfZ;AAt3BI;EA+3BM;IAQI,aAAA;EAbZ;AACF;AAeU;EAEE,eAAA;EACA,gBAAA;AAdZ;AA/3BI;EA04BM;IAKI,eAAA;EAZZ;AACF;AAp4BI;EAu3BI;IA6BI,oBAAA;EAZV;AACF;AAgBM;EACE,gBAAA;AAdR;AAgBQ;EACE,SAAA;AAdV;AAeU;EACE,aAAA;AAbZ;AAl5BI;EAq6BA;IAGI,mBAAA;EAlBN;AACF;AAmBM;EACE,kCAv7BE;EAw7BF,eAAA;EACA,gBAAA;AAjBR;AAkBQ;EACE,cAz7BH;EA07BG,gBAAA;AAhBV;AAiBU;EACE,cAAA;EACA,gCAAA;AAfZ;AAmBM;EACE,gBAAA;AAjBR;AAv6BI;EAu7BE;IAGI,gBAAA;EAfR;AACF;AAgBQ;EACE,cAAA;EACA,kCA18BA;EA28BA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,6BAAA;EACA,cA98BH;EA+8BG,mBAAA;AAdV;AAeU;EACE,YAAA;EACA,yBAl9BL;EAm9BK,yBAAA;EACA,gCAAA;AAbZ;AA77BI;EA47BI;IAiBI,kBAAA;IACA,eAAA;IACA,yBAAA;EAZV;AACF;AAgBI;EACE,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EAEA,yDAAA;EACA,4BAAA;EACA,4BAAA;AAfN;AA98BI;EAo9BA;IAYI,kBAAA;IACA,oBAAA;IACA,4BAAA;EAdN;AACF;AAj9BI;EAg9BA;IAiBI,oBAAA;EAZN;AACF;AAaM;EACE,cAl/BD;EAm/BC,kCAr/BE;EAs/BF,eAAA;AAXR;AA/9BI;EAu+BE;IAKI,eAAA;IACA,mBAAA;EATR;AACF;AAWM;EACE,cA3/BD;EA6/BC,gBAAA;EACA,kBAAA;EACA,cAAA;AAVR;AA3+BI;EAg/BE;IAOI,eAAA;EARR;AACF;AAUM;EACE,cAAA;EACA,kBAAA;EACA,kCAzgCE;EA0gCF,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cA5gCD;AAogCP;AAUQ;EACE,YAAA;EAEA,yBAjhCH;EAmhCG,yBAAA;EACA,gCAAA;AAVV;AAhgCI;EA0/BE;IAmBI,kBAAA;IACA,eAAA;EATR;AACF;;AAgBE;EACE,iBAAA;EACA,oBAAA;AAbJ;AAeM;EACE,kCAviCE;EAwiCF,eAAA;EACA,mBAAA;EACA,cAxiCD;EAyiCC,gBAAA;AAbR;AAlhCI;EA0hCE;IAQI,eAAA;EAZR;AACF;AAcM;EACE,kCAljCE;EAmjCF,mBAAA;EACA,gBAAA;AAZR;AAgBM;EACE,gBAAA;EACA,kCA1jCE;EA2jCF,qBAAA;EACA,gBAAA;EACA,cA3jCD;EA4jCC,gBAAA;AAdR;AAgBM;EACE,kCAjkCE;EAkkCF,mBAAA;EACA,gBAAA;AAdR;;AAmBA;EACE,sBAAA;EACA,YAAA;AAhBF;;AAkBA;EACE,yBAAA;AAfF;;AAiBA;EACE,yBAAA;AAdF;;AAkBE;EACE,iBAAA;EACA,oBAAA;AAfJ;AAgBI;EACE,kCAxlCI;EAylCJ,eAAA;EACA,mBAAA;EACA,cAzlCC;EA0lCD,gBAAA;AAdN;AAlkCI;EA2kCA;IAQI,eAAA;EAbN;AACF;AAeI;EACE,kCAnmCI;EAomCJ,mBAAA;EACA,gBAAA;AAbN;;AAkBA;EA3kCE,aAAA;AAikCF;AA5kCI;EAslCJ;IAGI,SAAA;EATF;EAUE;IACE,eAAA;EARJ;AACF;AA5lCI;EA8lCJ;IASI,sBAAA;IACA,aAAA;EAPF;AACF;AA9lCI;EA0lCJ;IAaI,sBAAA;IACA,aAAA;EALF;AACF;;AAQA;EACE,iBAAA;EACA,oBAAA;AALF;AA7mCI;EAgnCJ;IAII,iBAAA;IACA,oBAAA;EAHF;AACF;AAIE;EApmCA,aAAA;EAsmCE,8BAAA;AAEJ;AA3nCI;EAunCF;IAKI,sBAAA;IACA,aAAA;EAGJ;AACF;AADM;EACE,gBAAA;EACA,kCA9oCE;EA+oCF,gBAAA;EACA,eAAA;AAGR;AADM;EACE,kCAnpCE;EAopCF,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AAGR;AA9oCI;EAsoCE;IAOI,kBAAA;IACA,eAAA;EAKR;AACF;AAHM;EACE,kCA9pCE;EA+pCF,gBAAA;AAKR;AAxpCI;EAipCE;IAII,gBAAA;EAOR;AACF;AAJQ;EACE,WAAA;AAMV;AAhqCI;EAypCI;IAGI,WAAA;EAQV;AACF;;AADA,UAAA;AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAGF;;AAeA;EA/qCE,aAAA;EAorCA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AAXF;AANE;EACE,eAAA;AAQJ;AASE;EACE,YAAA;AAPJ;;AAWA;EACE,gBAAA;EACA,cAAA;AARF;;AAYE;EACE,qBAAA;AATJ;;AAaA;EACE,kBAAA;AAVF;AAYE;EACE,eAAA;EACA,6BAAA;AAVJ;AAWI;EACE,0BAAA;AATN;AAYE;EACE,8BAAA;AAVJ;AAaE;EACE,eAAA;EACA,mBAAA;EACA,kCAlwCM;AAuvCV;AAaE;EACE,mBAAA;AAXJ;AA9uCI;EA4vCA;IACE,eAAA;EAXJ;AACF;;AAiBA;EACE,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,wCAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,cAAA;EACA,cAAA;AAdF;AAhwCI;EAowCJ;IAYI,eAAA;EAZF;AACF;;AAeA;EACE,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kCAryCQ;EAsyCR,WAAA;EACA,mBAAA;AAZF;;AAcA;EACE,UAAA;EACA,mBAAA;AAXF;AApxCI;EA6xCJ;IAII,WAAA;EATF;AACF;;AAWA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AARF;;AAUA;EACE,UAAA;AAPF;;AASA;EACE,aAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,uBAAA;AANF;AAhzCI;EAizCJ;IAOI,WAAA;EAJF;AACF;;AAOA;EACE,gBAAA;EACA,kCA10CQ;EA20CR,mBAAA;AAJF;;AAOA;EACE,UAAA;EAEA,cAAA;EACA,kBAAA;EACA,kCAn1CQ;EAo1CR,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;AALF;AAOE;EACE,uBAAA;EAEA,yBA51CG;EA81CH,yBAAA;EACA,gCAAA;AAPJ;AA90CI;EAk0CJ;IAsBI,kBAAA;IACA,eAAA;EANF;AACF;;AASA;EACE,aAAA;AANF;;AASA,0BAAA;AACA;EACE,qBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;AANF;;AAQA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AALF;;AAOA;EACE,UAAA;EACA,kCA73CQ;EA83CR,eAAA;AAJF;;AAUA,uCAAA;AACA,uCAAA;AAEA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AARF;;AAWA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,eAAA;AARF;;AAWA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AARF;;AAWA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;AARF;;AAWA;EACE,cAAA;EACA,YAAA,EAAA,gCAAA;EACA,yDAAA;EACA,4BAAA;EACA,0BAAA;EACA,wBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AARF;;AAWA;EACE,6BAAA;AARF;;AAWA;EACE,kBAAA;EACA,kBAAA,EAAA,8BAAA;EACA,eAAA;AARF;;AAWA,4BAAA;AACA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;AARF;;AAWA,yDAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,wBAAA;AARF;;AAWA,sDAAA;AACA;EACE,cAAA;AARF;;AAWA,8BAAA;AACA;EACE,aAAA;AARF;;AAWA;EACE,cAAA;EACA,YAAA;AARF;AA/8CI;EAq9CJ;IAII,eAAA;EANF;AACF;AAOE;EACE,kCAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AALJ;AA79CI;EA29CF;IASI,eAAA;EAHJ;AACF;AAKE;EACE,gBAAA;AAHJ;AAr+CI;EAu+CF;IAGI,kBAAA;EADJ;AACF;AAEI;EACE,mBAAA;EACA,kCA1/CI;EA2/CJ,gBAAA;AAAN;AA/+CI;EA4+CA;IAMI,eAAA;EACN;AACF;;AAKA,6BAAA;AAqBA;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAtBF;AAwBE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAtBJ;AAwBE;EAEE,YAAA;AAvBJ;AA0BE;EACE,WAAA;EACA,YAAA;AAxBJ;AA1gDI;EAgiDF;IAII,WAAA;EAtBJ;AACF;;AA2BA;EACE,yBArjDK;EAsjDL,uBAAA;AAxBF;;AA2BA;EACE,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAxBF;;AA2BA;EACE,sBAAA;EACA,mBAAA;AAxBF;;AA2BA;EACE,cAAA;EACA,YAAA;AAxBF;AA+BA;EACE,cAAA;EACA,kBAAA;AA7BF;AA1iDI;EAqkDJ;IAII,eAAA;IACA,gBAAA;EA3BF;AACF;;AA8BA;EACE,WAAA;EACA,YAAA;AA3BF;;AAqCA,6BAAA;AAcA;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EAGA,kCA3nDQ;EA4nDR,gBAAA;AAjDF;AAmDE;EACE,mBAAA;EACA,cA9nDG;EA+nDH,kBAAA;EACA,kCAloDM;EAmoDN,gBAAA;EACA,eAAA;AAjDJ;AAvkDI;EAknDF;IAQI,mBAAA;IAEA,eAAA;IACA,eAAA;EAhDJ;AACF;AA9kDI;EAwmDJ;IA0BI,UAAA;IACA,iBAAA;IACA,YAAA;EAhDF;AACF;AAkDE;EACE,cAlpDG;EAmpDH,eAAA;EACA,iBAAA;EACA,mBAAA;AAhDJ;AAkDE;EACE,YAAA;EACA,gBAAA;AAhDJ;AAwDA;EACE,aAAA;EAEA,mBAAA;EACA,cAAA;EAEA,gBAAA;EACA,kCA1qDQ;EA4qDR,gCAAA;AAzDF;AAvmDI;EAupDJ;IAWI,mBAAA;EAvDF;AACF;;AA0DA;EACE,kCAnrDQ;EAorDR,iBAAA;AAvDF;;AA0DA;EACE,SAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAvDF;;AAyDA;EACE,yBAAA;AAtDF;;AAwDA;EAEE,kCApsDQ;AA8oDV;;AAyDA;EAEE,iBAAA;EACA,YAAA;EACA,kCA3sDQ;EA4sDR,0BAAA;EACA,iBAAA;EACA,mBAAA;AAvDF;AA4DA;EACE,kBAAA;EAGA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kCA1tDQ;AA8pDV;AAlpDI;EAusDJ;IASI,iBAAA;IACA,oBAAA;EA1DF;AACF;AA4DE;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AA1DJ;AA6DE;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AA3DJ;AA4DI;EACE,iBAAA;EACA,kCA9uDI;EA+uDJ,yBAAA;AA1DN;AA4DI;EACE,cAhvDC;AAsrDP;AA4DI;EACE,eAAA;AA1DN;;AA8DA;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,kCA9vDQ;EAgwDR,cA9vDK;EA+vDL,kBAAA;EACA,yBAAA;AA5DF;AA1rDI;EA6uDJ;IAeI,kBAAA;EA9DF;AACF;;AAiEA;EAEE,YAAA;EACA,kBAAA;AA/DF;;AAkEA;EACE,cAAA;EACA,kBAAA;EACA,kCArxDQ;EAsxDR,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAxxDK;EAyxDL,YAAA;EACA,mBAAA;AA/DF;AAiEE;EACE,YAAA;EACA,yBA9xDG;EA+xDH,yBAAA;EACA,gCAAA;AA/DJ;AAvtDI;EAswDJ;IAmBI,kBAAA;IACA,eAAA;EA9DF;AACF;;AAiEA;EACE,uBAAA;EACA,cA1yDK;EA2yDL,mBAAA;AA9DF;;AAgEA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;AA7DF;AA8DE;EACE,qBAAA;EACA,cAAA;EAUA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;AArEJ;AApvDI;EAyyDF;IAkBI,kBAAA;IACA,SAAA;IACA,aAAA;IACA,YAAA;EAnEJ;AACF;;AAsEA;EACE,qBAAA;EACA,6BAAA;EACA,SAAA;EAEA,gCAAA;EACA,yBAAA;AAnEF;AArwDI;EAk0DJ;IAQI,WAAA;EAjEF;AACF;;AAmEA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;AAhEF;AAtxDI;EA60DJ;IAWI,QAAA;IACA,UAAA;EA9DF;AACF;;AAiEA;EACE,kBAAA;AA9DF;AA+DE;EACE,oBAAA;AA7DJ;AAnyDI;EA+1DF;IAGI,oBAAA;EA3DJ;AACF;AApyDI;EA21DF;IAMI,qBAAA;EAzDJ;AACF;AA2DE;EACE,kBAAA;AAzDJ;AAhzDI;EAw2DF;IAGI,kBAAA;EAvDJ;AACF;AAyDE;EACE,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,kBAAA;EACA,QAAA,EAAA,sEAAA;EACA,SAAA,EAAA,sEAAA;EAEA,gCAAA;EACA,UAAA;AAxDJ;AA/zDI;EA82DF;IAWI,QAAA,EAAA,sEAAA;IACA,SAAA,EAAA,sEAAA;IACA,WAAA;IACA,gCAAA;EAtDJ;AACF;AAn0DI;EA02DF;IAiBI,QAAA;EApDJ;AACF;;AAyDE;EACE,UAAA;AAtDJ;AAwDE;EACE,yBAAA;EACA,iBAAA;EACA,oBAAA;AAtDJ;AAwDI;EACE,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;AAtDN;AA51DI;EA64DA;IAOI,aAAA;IACA,sBAAA;EApDN;AACF;AAqDM;EACE,SAAA;EACA,eAAA;EACA,YAAA;EACA,kCAv6DE;AAo3DV;AAx2DI;EAu5DE;IAMI,eAAA;EAjDR;AACF;AAmDM;EACE,SAAA;AAjDR;AAkDQ;EACE,YAAA;EACA,kCAh7DA;EAi7DA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAhDV;AAoDU;EACE,oBAAA;AAlDZ;AAuDI;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,qDAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;AArDN;AAr4DI;EAk7DA;IAUI,sBAAA;IACA,aAAA;IACA,gBAAA;EAnDN;AACF;AAoDM;EACE,kCA78DE;EA88DF,eAAA;EACA,cAAA;EACA,SAAA;AAlDR;AAl5DI;EAg8DE;IAMI,eAAA;EAhDR;AACF;AAkDM;EACE,SAAA;AAhDR;AAkDU;EACE,mBAAA;EACA,kCA19DF;EA29DE,mBAAA;AAhDZ;AA/5DI;EA48DM;IAKI,kBAAA;EA9CZ;AACF;AAp6DI;EAm9DQ;IAEI,mBAAA;EA7Cd;AACF;AAgDY;EACE,cAp+DP;EAq+DO,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AA9Cd;AAh7DI;EAy9DQ;IAOI,eAAA;IACA,gBAAA;EA5Cd;AACF;AA8CY;EAGE,eAAA;EACA,gBAAA;AA9Cd;AA17DI;EAo+DQ;IAMI,eAAA;EA5Cd;AACF;AA6Cc;EACE,cAv/DT;EAw/DS,gBAAA;AA3ChB;AA6CgB;EACE,cAAA;EACA,gCAAA;AA3ClB;AAiDQ;EACE,mBAAA;AA/CV;AAgDU;EACE,mBAAA;AA9CZ;AAgDY;EACE,yBAxgEP;EAygEO,aAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;EACA,YAAA;EACA,kCAphEJ;EAqhEI,mBAAA;EACA,eAAA;AA9Cd;AA59DI;EA6/DQ;IAeI,eAAA;EA5Cd;AACF;AA8CY;EACE,aAAA;EACA,yBAAA;EAEA,kCA/hEJ;EAgiEI,eAAA;EACA,+BAAA;EACA,gCAAA;EACA,iDAAA;AA7Cd;AA1+DI;EA+gEQ;IAUI,eAAA;EA3Cd;AACF;AAgDU;EACE,aAAA;EACA,kBAAA;AA9CZ;AA+CY;EACE,SAAA;AA7Cd;AA+CY;EACE,SAAA;AA7Cd","sourcesContent":["@font-face {\n  font-family: \"Roboto Mono It\";\n  src: url(\"../fonts/RobotoMono-Italic.woff2\") format(\"woff2\"),\n    url(\"../fonts/RobotoMono-Italic.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Roboto Mono Regular\";\n  src: url(\"../fonts/RobotoMono-Regular.woff2\") format(\"woff2\"),\n    url(\"../fonts/RobotoMono-Regular.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Montserrat\";\n  src: url(\"../fonts/Montserrat-Thin.woff2\") format(\"woff2\"),\n    url(\"../fonts/Montserrat-Thin.woff\") format(\"woff\");\n  font-weight: 100;\n  font-style: normal;\n  font-display: swap;\n}\n\n/* VARIABLES */\n\n$mont: \"Montserrat\";\n$regular: \"Roboto Mono Regular\";\n$italic: \"Roboto Mono It\";\n$blue: #3b20e2;\n\n/* MIXINS */\n\n@mixin mq($size) {\n  @if $size==xs {\n    @media (max-width: 320px) {\n      @content;\n    }\n  } @else if $size==mobile {\n    @media (max-width: 767px) {\n      @content;\n    }\n  } @else if $size==tab {\n    @media only screen and (min-width: 768px) and (max-width: 1024px) {\n      @content;\n    }\n  } @else if $size==desktop {\n    @media only screen and (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin flexbox {\n  display: -webkit-box; // old\n  display: -moz-box; // old\n  display: -ms-flexbox; // ie\n  display: -webkit-flex; // new\n  display: flex; // new\n}\n\n@mixin opacity($opacity) {\n  opacity: $opacity;\n  $opacity-ie: $opacity * 100;\n  filter: alpha(opacity=$opacity-ie); //IE8\n}\n\n@mixin input-placeholder {\n  &.placeholder {\n    @content;\n  }\n  &:-moz-placeholder {\n    @content;\n  }\n  &::-moz-placeholder {\n    @content;\n  }\n  &:-ms-input-placeholder {\n    @content;\n  }\n  &::-webkit-input-placeholder {\n    @content;\n  }\n}\n\n/* RESET CSS */\n\n/* http://meyerweb.com/eric/tools/css/reset/\n         v2.0 | 20110126\n         License: none (public domain)\n      */\n\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  color: inherit;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\n/* HTML5 display-role reset for older browsers */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block;\n}\nbody {\n  line-height: 1;\n}\nol,\nul {\n  list-style: none;\n}\nblockquote,\nq {\n  quotes: none;\n}\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n  content: \"\";\n  content: none;\n}\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n* {\n  box-sizing: border-box;\n}\n\na {\n  &,\n  &:hover,\n  &:active,\n  &:visited,\n  &:focus {\n    color: inherit;\n  }\n\n  text-decoration: none;\n}\n\ni,\nem,\n.italic-text {\n  font-style: italic;\n}\nb,\nstrong,\nth,\n.bold-text {\n  //font-weight: bold;\n}\n.left {\n  float: left;\n}\n.right {\n  float: right;\n}\n\n.wrap-clear::after {\n  content: \"\";\n  display: block;\n  clear: both;\n}\n.clearfix {\n  zoom: 1;\n  display: table;\n  clear: both;\n\n  &:before,\n  &:after {\n    content: \"\";\n    display: table;\n  }\n\n  &:after {\n    clear: both;\n  }\n}\n\n:focus {\n  outline: none;\n}\n\ninput,\nbutton,\ntextarea {\n  border-radius: 0;\n  appearance: none;\n}\n\nselect {\n  border-radius: 0;\n}\n\ntextarea {\n  resize: none;\n}\n\n/* COMMONS */\n\nbody {\n  -webkit-font-smoothing: antialiased;\n  letter-spacing: 0.6px;\n}\n\nol,\nul {\n  margin: 0px;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n  -webkit-appearance: none;\n  outline: none;\n  border-radius: 0;\n  background-color: transparent;\n}\n\ninput,\ntextarea {\n  background: transparent;\n  border: none;\n}\n\ninput:focus,\nselect:focus,\ntextarea:focus,\nbutton:focus,\na:focus {\n  outline: none;\n}\n\na {\n  color: inherit;\n  cursor: pointer;\n}\n\n.h1,\n.h2,\n.h3,\n.h4,\nh1,\nh2,\nh3,\nh4 {\n  line-height: 1.2;\n}\n\np {\n  line-height: 1.3;\n}\nimg {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.slick-next:before,\n.slick-prev:before {\n  content: \"\";\n}\n\n.scroll-lock {\n  height: 100%;\n  overflow-y: hidden;\n\n  @include mq(mobile) {\n    // overflow-y: visible;\n  }\n}\n\nsmall {\n  font-size: 13px;\n}\n\n.input[type=\"checkbox\"] {\n  -webkit-appearance: checkbox;\n  box-sizing: border-box;\n}\nhtml {\n  scroll-behavior: smooth;\n}\n\n.hidden-lg {\n  @include mq(desktop) {\n    display: none !important;\n  }\n}\n.hidden-xs {\n  @include mq(mobile) {\n    display: none !important;\n  }\n}\n.hidden-md {\n  @include mq(tab) {\n    display: none !important;\n  }\n}\n\n.img-responsive {\n  width: 100%;\n  height: auto;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 90%;\n\n  @include mq(tab) {\n    width: 90%;\n    max-width: 768px;\n    margin: 0 auto;\n  }\n  @include mq(mobile) {\n    width: 100%;\n    padding: 0 20px;\n    margin: 0 auto;\n  }\n}\n// common\n.common-bg {\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\np {\n  font-size: 15px;\n  @include mq(mobile) {\n    font-size: 15px;\n  }\n}\n\nh2 {\n  font-weight: 600;\n}\nmain {\n  @include mq(mobile) {\n    padding-top: 65px;\n  }\n}\nheader {\n  background-color: #3b20e2;\n  .logo {\n    color: white;\n    font-family: $regular;\n    font-size: 26px;\n    line-height: 1.2;\n  }\n  a {\n    color: white;\n    font-family: $regular;\n    display: inline-block;\n    font-size: 19px;\n    line-height: 1.2;\n  }\n  .navbar {\n    padding-top: 32px;\n    padding-bottom: 32px;\n    @include flexbox();\n    justify-content: space-between;\n    .nav {\n      display: flex;\n      column-gap: 60px;\n      align-items: flex-start;\n      .nav-item {\n        padding-bottom: 5px;\n        color: white;\n        &.active {\n          color: #f6fe01;\n          border-bottom: #f6fe01 solid 1px;\n        }\n      }\n    }\n  }\n}\n#navbar {\n  transition: 0.7s;\n}\nheader {\n  padding-top: 30px;\n  padding-bottom: 15px;\n  @include mq(mobile) {\n    position: fixed;\n    transition: top 0.6s ease-in-out;\n    left: 0;\n    right: 0;\n    z-index: 5000;\n    z-index: 5000;\n    padding-top: 15px;\n    padding-bottom: 15px;\n  }\n  @include mq(tab) {\n    padding-top: 15px;\n    padding-bottom: 10px;\n  }\n  .header-main {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    a {\n      display: inline-block;\n      font: 18px $regular;\n      color: white;\n      display: block;\n      border-bottom: 1px solid transparent;\n      #logo-brand {\n        transition: 0.6s;\n        font-size: 26px;\n        line-height: 1.2;\n      }\n      img {\n        display: inline-block;\n        width: 80px;\n        @include mq(mobile) {\n          width: 60px;\n        }\n        @include mq(tab) {\n          width: 61px;\n        }\n      }\n      display: inline-block;\n      @include mq(mobile) {\n        font-size: 20px;\n      }\n      @include mq(tab) {\n        font-size: 24px;\n      }\n    }\n\n    .brand {\n      font-size: 26px;\n      line-height: 1.2;\n      @include mq(mobile) {\n        font-size: 22px;\n      }\n    }\n    .nav-menu {\n      display: flex;\n      gap: 2.5rem;\n      @include mq(mobile) {\n        padding-top: 80px;\n        z-index: -1;\n        position: fixed;\n        left: -100%;\n        top: 70px;\n        gap: 0;\n        flex-direction: column;\n        width: 100%;\n        min-height: 100vh;\n        text-align: center;\n        transition: 0.3s;\n        overflow: hidden;\n        background-color: $blue;\n\n        &.active {\n          left: 0;\n          @include mq(mobile) {\n            //padding-top: 60px;\n          }\n        }\n        .nav-item {\n          margin: 16px 0;\n          @include mq(mobile) {\n            margin: 10px 0;\n          }\n        }\n      }\n      @include mq(tab) {\n        // z-index: -1;\n        position: fixed;\n        left: -100%;\n        top: 100px;\n        gap: 0;\n        flex-direction: column;\n        width: 100%;\n        min-height: 100vh;\n        text-align: center;\n        transition: 0.3s;\n        background-color: $blue;\n        &.active {\n          left: 0;\n          padding-top: 3rem;\n        }\n        .nav-item {\n          margin: 10px 0;\n        }\n      }\n    }\n    .nav-item {\n      &:hover {\n        color: #f6fe01;\n      }\n      &.active {\n        color: #f6fe01;\n        border-bottom: 1px solid #f6fe01;\n        padding-bottom: 10px;\n      }\n      @include mq(tab) {\n        line-height: 2;\n      }\n      .nav-link {\n        display: inline-block;\n        position: relative;\n        &:after {\n          content: \"\";\n          position: absolute;\n          width: 100%;\n          transform: scaleX(0);\n          height: 2px;\n          bottom: -18px;\n          left: 0;\n          background-color: white;\n          transform-origin: bottom right;\n          transition: transform 0.25s ease-out;\n        }\n        &:hover::after {\n          transform: scaleX(1);\n          transform-origin: bottom left;\n        }\n      }\n    }\n\n    .hamburger {\n      display: none;\n      cursor: pointer;\n      .bar {\n        display: block;\n        width: 25px;\n        height: 3px;\n        margin: 5px auto;\n        transition: all 0.3s ease-in-out;\n        background-color: white;\n        &:nth-child(1) {\n          opacity: 0;\n        }\n        @include mq(tab) {\n          width: 35px;\n        }\n      }\n      @include mq(mobile) {\n        display: block;\n\n        &.active .bar:nth-child(1) {\n          opacity: 1;\n          transform: translate(0px, 8px) rotate(45deg);\n        }\n        &.active .bar:nth-child(2) {\n          opacity: 0;\n        }\n        &.active .bar:nth-child(3) {\n          transform: translate(0px, -8px) rotate(-45deg);\n        }\n      }\n      @include mq(tab) {\n        display: block;\n\n        &.active .bar:nth-child(1) {\n          opacity: 1;\n          transform: translate(0px, 8px) rotate(45deg);\n        }\n        &.active .bar:nth-child(2) {\n          opacity: 0;\n        }\n        &.active .bar:nth-child(3) {\n          transform: translate(0px, -8px) rotate(-45deg);\n        }\n      }\n    }\n  }\n}\n\n.banner {\n  background-color: $blue;\n\n  .wrapper {\n    display: flex;\n    justify-content: center;\n    padding-top: 60px;\n    padding-bottom: 60px;\n    gap: 4rem;\n\n    @include mq(mobile) {\n      gap: 2rem;\n      padding-top: 40px;\n      padding-bottom: 40px;\n      flex-direction: column;\n    }\n\n    &.flex-donate {\n      gap: 0;\n      @include mq(mobile) {\n        gap: 2rem;\n      }\n    }\n\n    .flex-home {\n      flex: 3 1;\n\n      h1 {\n        font-family: $regular;\n        font-size: 60px;\n        line-height: 1.1;\n        font-weight: 700;\n        text-transform: capitalize;\n        color: white;\n        display: inline;\n\n        @include mq(mobile) {\n          font-size: 22px;\n        }\n        @include mq(tab) {\n          font-size: 33px;\n        }\n      }\n      h2 {\n        font-family: $regular;\n        font-size: 60px;\n        line-height: 1.1;\n        font-weight: 700;\n        text-transform: capitalize;\n        color: white;\n        background: #3b20e2;\n        display: inline;\n        line-height: 1.5;\n      }\n      h3 {\n        font-family: $regular;\n        font-size: 60px;\n        line-height: 1.1;\n        font-weight: 700;\n        text-transform: capitalize;\n        color: white;\n        background: #3b20e2;\n        display: inline;\n      }\n      p {\n        margin-top: 2rem;\n        font-family: \"Roboto Mono Regular\";\n        color: white;\n        font-size: 24px;\n        @include mq(mobile) {\n          max-width: 100%;\n          font-size: 16px;\n        }\n        @include mq(tab) {\n          font-size: 16px;\n        }\n      }\n\n      a {\n        margin-top: 2rem;\n        display: inline-block;\n        padding: 20px 40px;\n        font-family: $regular;\n        font-size: 24px;\n        border: 2px white solid;\n        border-radius: 10px;\n        color: white;\n        align-self: flex-start;\n        &:hover {\n          color: $blue;\n          background-color: white;\n          border: 2px white solid;\n          transition: 0.3s all ease-in-out;\n        }\n        @include mq(mobile) {\n          padding: 10px 20px;\n          font-size: 18px;\n          border: 1px white solid;\n        }\n      }\n      @include mq(mobile) {\n        h2 {\n          font-size: 36px;\n        }\n      }\n    }\n    .flex-img {\n      flex: 3 1;\n      .donate-hero-img {\n        width: 70%;\n        margin-left: auto;\n        @include mq(mobile) {\n          width: 70%;\n          margin: auto;\n        }\n        @include mq(tab) {\n          width: 100%;\n          margin: auto;\n        }\n      }\n    }\n  }\n  @include mq(desktop) {\n    border-top: 15px solid $blue;\n    border-bottom: 15px solid $blue;\n  }\n  @include mq(mobile) {\n    flex-direction: column;\n  }\n}\n.about {\n  background-color: #f5f5f5;\n  .wrapper {\n    padding-top: 30px;\n    padding-bottom: 30px;\n    @include mq(mobile) {\n      padding-top: 40px;\n    }\n    .donate-copy-header {\n      font-family: $regular;\n      font-size: 30px;\n      margin-bottom: 1rem;\n      color: $blue;\n      line-height: 1.5;\n      font-weight: 600;\n\n      @include mq(mobile) {\n        font-size: 25px;\n      }\n    }\n    h2 {\n      font-family: $regular;\n      font-size: 41px;\n      margin-bottom: 1rem;\n      color: white;\n      line-height: 1.2;\n\n      @include mq(mobile) {\n        font-size: 25px;\n      }\n    }\n    h3 {\n      font-family: $regular;\n      font-size: 30px;\n      margin-bottom: 1rem;\n      color: $blue;\n      line-height: 1.5;\n\n      @include mq(mobile) {\n        font-size: 25px;\n      }\n    }\n\n    p {\n      font-family: $regular;\n      margin-bottom: 25px;\n      line-height: 1.5;\n      // font-weight: 700;\n      @include mq(mobile) {\n        line-height: 1.4;\n      }\n    }\n\n    .column-wrap {\n      .column {\n        padding: 50px;\n        background-color: #3b20e2;\n        color: white;\n        border-radius: 10px;\n        @include mq(mobile) {\n          padding: 35px 20px;\n        }\n        .copy-wrap-dl {\n          margin-top: 40px;\n          display: flex;\n          flex-direction: column;\n          justify-content: space-between;\n          height: 250px;\n          align-items: flex-start;\n          @include mq(mobile) {\n            height: unset;\n          }\n        }\n\n        .copy-delegation {\n          // margin-top: 40px;\n          line-height: 1.4;\n          font-weight: unset;\n          margin-bottom: 40px;\n          font-size: 16px;\n          @include mq(mobile) {\n            margin-top: 20px;\n            margin-bottom: 20px;\n            font-size: 16px;\n          }\n        }\n        a {\n          display: inline-block;\n          padding: 20px 40px;\n          font-family: $regular;\n          font-size: 24px;\n          border: 2px white solid;\n          border-radius: 10px;\n          &:hover {\n            color: $blue;\n            background-color: white;\n            border: 2px white solid;\n            transition: 0.3s all ease-in-out;\n          }\n          @include mq(mobile) {\n            padding: 10px 20px;\n            font-size: 18px;\n            border: 1px white solid;\n          }\n        }\n\n        &.col-del {\n          background-image: url(\"../images/delegation.png\");\n          background-repeat: no-repeat;\n          background-position: 96% 4%;\n          @include mq(mobile) {\n            background-size: 28%;\n            background-position: 95% 4%;\n          }\n        }\n        &.col-liq {\n          background-image: url(\"../images/liquidity.png\");\n          background-repeat: no-repeat;\n          background-position: 95% 10%;\n\n          // display: flex;\n          flex-direction: column;\n          align-items: flex-start;\n          .copy-wrap-dl {\n            margin-top: 40px;\n            display: flex;\n            flex-direction: column;\n            justify-content: space-between;\n            height: 250px;\n            align-items: flex-start;\n            @include mq(mobile) {\n              height: unset;\n            }\n          }\n          p {\n            // margin-top: 2rem;\n            font-size: 16px;\n            font-weight: 400;\n            @include mq(mobile) {\n              font-size: 16px;\n            }\n          }\n\n          @include mq(mobile) {\n            background-size: 28%;\n          }\n        }\n      }\n\n      &.column-wrap-2 {\n        margin-top: 30px;\n\n        .col-del {\n          flex: 1;\n          .copy-wrap-dl {\n            height: unset;\n          }\n        }\n      }\n    }\n\n    .column-wrap-page {\n      // padding-bottom: 50px;\n      @include mq(mobile) {\n        padding-bottom: 0px;\n      }\n      p {\n        font-family: $regular;\n        font-size: 15px;\n        line-height: 1.5;\n        .link-a {\n          color: $blue;\n          font-weight: 700;\n          &:hover {\n            color: #08d0ae;\n            transition: all 0.2s ease-in-out;\n          }\n        }\n      }\n      .page-btn {\n        margin-top: 55px;\n        @include mq(mobile) {\n          margin-top: 30px;\n        }\n        a {\n          display: table;\n          font-family: $regular;\n          padding: 20px 40px;\n          font-size: 24px;\n          border: 2px $blue solid;\n          border-radius: 10px;\n          background-color: transparent;\n          color: $blue;\n          margin-bottom: 18px;\n          &:hover {\n            color: white;\n            background-color: $blue;\n            border: 2px $blue solid;\n            transition: 0.3s all ease-in-out;\n          }\n          @include mq(mobile) {\n            padding: 10px 20px;\n            font-size: 18px;\n            border: 1px $blue solid;\n          }\n        }\n      }\n    }\n    .donate {\n      margin-top: 20px;\n      background-color: white;\n      border-radius: 8px;\n      padding: 50px;\n      flex-direction: column;\n\n      background-image: url(\"../images/danate.png\");\n      background-repeat: no-repeat;\n      background-position: 96% 10%;\n\n      @include mq(mobile) {\n        padding: 35px 20px;\n        background-size: 45%;\n        background-position: 95% 10%;\n      }\n      @include mq(tab) {\n        background-size: 50%;\n      }\n      h2 {\n        color: $blue;\n        font-family: $regular;\n        font-size: 41px;\n        @include mq(mobile) {\n          font-size: 32px;\n          margin-bottom: 15px;\n        }\n      }\n      .copy-donate {\n        color: $blue;\n\n        line-height: 1.4;\n        font-weight: unset;\n        max-width: 40%;\n        @include mq(mobile) {\n          max-width: 100%;\n        }\n      }\n      a {\n        display: table;\n        padding: 20px 40px;\n        font-family: $regular;\n        font-size: 24px;\n        border: 2px $blue solid;\n        border-radius: 10px;\n        background-color: white;\n        color: $blue;\n\n        &:hover {\n          color: white;\n\n          background-color: $blue;\n\n          border: 2px $blue solid;\n          transition: 0.3s all ease-in-out;\n        }\n        @include mq(mobile) {\n          padding: 12px 22px;\n          font-size: 18px;\n        }\n      }\n    }\n  }\n}\n\n.description {\n  .wrapper {\n    padding-top: 30px;\n    padding-bottom: 30px;\n    .title {\n      h2 {\n        font-family: $regular;\n        font-size: 30px;\n        margin-bottom: 1rem;\n        color: $blue;\n        line-height: 1.5;\n\n        @include mq(mobile) {\n          font-size: 25px;\n        }\n      }\n      p {\n        font-family: $regular;\n        margin-bottom: 1rem;\n        line-height: 1.5;\n      }\n    }\n    .copy {\n      h2 {\n        padding-top: 5px;\n        font-family: $regular;\n        margin-bottom: 0.5rem;\n        font-weight: 700;\n        color: $blue;\n        line-height: 1.5;\n      }\n      p {\n        font-family: $regular;\n        margin-bottom: 1rem;\n        line-height: 1.5;\n      }\n    }\n  }\n}\nfooter {\n  background-color: #000;\n  color: white;\n}\n.grey {\n  background-color: #f5f5f5;\n}\nhr {\n  border: 1px solid #c3bfbf;\n}\n\n.about1 {\n  .wrapper {\n    padding-top: 30px;\n    padding-bottom: 30px;\n    h2 {\n      font-family: $regular;\n      font-size: 30px;\n      margin-bottom: 1rem;\n      color: $blue;\n      line-height: 1.5;\n\n      @include mq(mobile) {\n        font-size: 25px;\n      }\n    }\n    p {\n      font-family: $regular;\n      margin-bottom: 1rem;\n      line-height: 1.5;\n    }\n  }\n}\n\n.column-wrap {\n  @include flexbox();\n  @include mq(desktop) {\n    gap: 20px;\n    .column {\n      flex-basis: 50%;\n    }\n  }\n  @include mq(mobile) {\n    flex-direction: column;\n    row-gap: 20px;\n  }\n  @include mq(tab) {\n    flex-direction: column;\n    row-gap: 20px;\n  }\n}\n\nfooter {\n  padding-top: 50px;\n  padding-bottom: 50px;\n  @include mq(mobile) {\n    padding-top: 40px;\n    padding-bottom: 40px;\n  }\n  .wrapper {\n    @include flexbox();\n    justify-content: space-between;\n\n    @include mq(mobile) {\n      flex-direction: column;\n      row-gap: 20px;\n    }\n    .col {\n      .logo {\n        line-height: 1.2;\n        font-family: $regular;\n        font-weight: 700;\n        font-size: 24px;\n      }\n      .head {\n        font-family: $regular;\n        font-weight: 700;\n        font-size: 24px;\n        margin-bottom: 10px;\n        color: #807f80;\n        @include mq(mobile) {\n          margin-bottom: 5px;\n          font-size: 20px;\n        }\n      }\n      a {\n        font-family: $regular;\n        line-height: 1.9;\n        @include mq(mobile) {\n          line-height: 1.4;\n        }\n      }\n      .brand {\n        img {\n          width: 90px;\n          @include mq(mobile) {\n            width: 75px;\n          }\n        }\n      }\n    }\n  }\n}\n\n/* MODAL */\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n}\n\n// .modal-content {\n//   background-color: #29292e;\n//   padding: 30px 0px;\n//   padding-bottom: 20px;\n//   border-radius: 8px;\n//   box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n//   font-family: $regular;\n//   position: relative;\n//   // min-width: 240px;\n//   color: white;\n//   @include mq(mobile) {\n//     padding-top: 30px;\n//   }\n// }\n\n.modal-close-button {\n  span {\n    font-size: 26px;\n  }\n  @include flexbox();\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  font-size: 18px;\n  width: 22px;\n  height: 22px;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  background: #efefef;\n  border-radius: 50%;\n  color: gray;\n  &:hover {\n    color: black;\n  }\n}\n\n.qr-code {\n  max-width: 320px;\n  margin: 0 auto;\n}\n\n.container {\n  a {\n    word-wrap: break-word;\n  }\n}\n\n.qr-wallet {\n  text-align: center;\n\n  .wallet-tc {\n    font-size: 10px;\n    margin-bottom: 0px !important;\n    .hover-tc:hover {\n      text-decoration: underline;\n    }\n  }\n  .wallet-address {\n    margin-bottom: 10px !important;\n  }\n  // font-size: 24px;\n  h4 {\n    font-size: 22px;\n    margin-bottom: 20px;\n    font-family: $regular;\n  }\n  .qr-wrap {\n    margin-bottom: 20px;\n  }\n  @include mq(mobile) {\n    .wallet-address {\n      font-size: 11px;\n    }\n  }\n}\n\n// ? form\n\n.form-container {\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  margin: 0 auto;\n  max-width: 70%;\n  @include mq(mobile) {\n    max-width: 100%;\n  }\n}\n\n.form-input {\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  margin-bottom: 10px;\n  font-family: $regular;\n  width: 100%;\n  color: rgb(5, 5, 5);\n}\n.div-form {\n  width: 45%;\n  margin-bottom: 10px;\n  @include mq(mobile) {\n    width: 100%;\n  }\n}\n.class-checkbox {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n.wallet-ad {\n  width: 70%;\n}\n.div-tick {\n  display: flex;\n}\n\n.checkbox-group {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  width: 80%;\n  justify-content: center;\n  @include mq(mobile) {\n    width: 100%;\n  }\n}\n\n.checkbox-group label {\n  margin-left: 5px;\n  font-family: $regular;\n  margin-bottom: 10px;\n}\n\n.submit-btn {\n  width: 60%;\n\n  display: table;\n  padding: 10px 30px;\n  font-family: $regular;\n  font-size: 16px;\n  border: 2px $blue solid;\n  border-radius: 10px;\n  background-color: white;\n  text-align: center;\n  color: $blue !important;\n\n  &:hover {\n    color: white !important;\n\n    background-color: $blue;\n\n    border: 2px $blue solid;\n    transition: 0.3s all ease-in-out;\n  }\n  @include mq(mobile) {\n    padding: 12px 22px;\n    font-size: 18px;\n  }\n}\n\ninput[type=\"checkbox\"] {\n  display: none;\n}\n\n/* Style the custom tick */\n.custom-tick {\n  display: inline-block;\n  width: 20fpx;\n  height: 16px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  margin-right: 8px;\n}\n.custom-tick svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.error {\n  color: red;\n  font-family: $regular;\n  font-size: 12px;\n}\n.submit-btn {\n}\n\n// !\n/* styles.css (or any other CSS file) */\n/* styles.css (or any other CSS file) */\n\n.form-checkbox {\n  position: relative;\n  padding-left: 30px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.form-checkbox input {\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.form-checkbox .checkmark {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 20px;\n  height: 20px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.form-checkbox .checkmark::after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n.form-checkbox input:checked + .checkmark::after {\n  display: block;\n  content: \"\\2713\"; /* Checkmark Unicode character */\n  background-image: url(\"../images/check-solid.svg\");\n  background-repeat: no-repeat;\n  background-position: right;\n  background-size: contain;\n  text-align: center;\n  line-height: 20px;\n  font-size: 24px;\n  color: transparent;\n}\n\n.form-checkbox input:required:not(:checked) + .checkmark {\n  border-color: rgb(76, 0, 255);\n}\n// ?/* Styling the custom checkbox container */\n.custom-checkbox {\n  position: relative;\n  padding-left: 25px; /* Space for the custom tick */\n  cursor: pointer;\n}\n\n/* Styling the custom tick */\n.custom-checkbox .checkbox-tick {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 20px;\n  width: 20px;\n  background-color: #fff;\n  border: 2px solid #333;\n  border-radius: 3px;\n}\n\n/* Styling the custom tick when the checkbox is checked */\n.custom-checkbox .checkbox-tick::after {\n  content: \"\";\n  position: absolute;\n  display: none;\n  left: 6px;\n  top: 2px;\n  width: 5px;\n  height: 10px;\n  border: solid #007bff;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n/* Show the custom tick when the checkbox is checked */\n.custom-checkbox input:checked + .checkbox-tick::after {\n  display: block;\n}\n\n/* Hide the default checkbox */\n.custom-checkbox input {\n  display: none;\n}\n// ? terms and condition\n.terms-c {\n  max-width: 60%;\n  margin: auto;\n  @include mq(mobile) {\n    max-width: 100%;\n  }\n  h2 {\n    font-family: \"Roboto Mono Regular\";\n    font-size: 30px;\n    margin-bottom: 1rem;\n    margin-top: 1rem;\n    color: #3b20e2;\n    line-height: 1.5;\n    text-align: center;\n    @include mq(mobile) {\n      font-size: 20px;\n    }\n  }\n  ul {\n    list-style: auto;\n    @include mq(mobile) {\n      padding-left: 30px;\n    }\n    li {\n      margin-bottom: 20px;\n      font-family: $regular;\n      line-height: 1.6;\n      // text-align: justify;\n      @include mq(mobile) {\n        font-size: 14px;\n      }\n    }\n  }\n}\n\n// donate form modal\n/* Add your other styles... */\n\n.donate-modal {\n  // position: fixed;\n  // top: 0;\n  // left: 0;\n  // width: 100%;\n  // height: 100%;\n  // background-color: rgba(0, 0, 0, 0.5);\n  // display: flex;\n  // justify-content: center;\n  // align-items: center;\n}\n\n// .modal-content {\n//   background-color: rgb(255, 255, 255);\n//   padding: 20px 0;\n//   border-radius: 8px;\n//   text-align: center;\n// }\n\n.options button {\n  margin: 15px;\n  padding: 18px 16px;\n  border: none;\n  cursor: pointer;\n\n  .wrapper-icon {\n    display: flex;\n    align-items: center;\n    width: 25px;\n    height: 25px;\n    margin: auto;\n  }\n  .credit-card {\n    // width: 20px;\n    margin: auto;\n    // height: 20px;\n  }\n  .crypto-card {\n    width: 16px;\n    margin: auto;\n    @include mq(mobile) {\n      width: 13px;\n    }\n    // height: 20px;\n  }\n}\n\n.options button.selected {\n  background-color: $blue;\n  color: white !important;\n}\n\n.pay-now-btn {\n  padding: 10px 20px;\n  background-color: #2ecc71;\n  border: none;\n  color: white;\n  cursor: pointer;\n}\n\n.pay-now-btn:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.amount-input {\n  margin: 10px 0;\n  color: black;\n  @include mq(mobile) {\n    .break-line {\n    }\n  }\n}\n\n.amount-input label {\n  display: block;\n  margin-bottom: 5px;\n  @include mq(mobile) {\n    font-size: 14px;\n    line-height: 1.4;\n  }\n}\n\n.amount-input input {\n  width: 100%;\n  padding: 8px;\n}\n\n// .total-amount {\n//   margin: 10px 0;\n//   border-top: 1px solid #ccc;\n//   padding-top: 10px;\n// }\n\n//\n/* Add your other styles... */\n\n.donate-modal {\n  // position: fixed;\n  // top: 0;\n  // left: 0;\n  // width: 100%;\n  // height: 100%;\n  // background-color: rgba(0, 0, 0, 0.5);\n  // display: flex;\n  // justify-content: center;\n  // align-items: center;\n}\n\n.modal-content {\n  background-color: white;\n  padding: 30px 0;\n  border-radius: 8px;\n  text-align: center;\n  // width: 70%; /* Set the width to 70% of the viewport */\n  // max-width: 600px; /* Add a maximum width to maintain readability */\n  font-family: $regular;\n  max-width: 900px;\n\n  .copy-head {\n    margin-bottom: 40px;\n    color: $blue;\n    text-align: center;\n    font-family: $regular;\n    font-weight: 700;\n    font-size: 19px;\n    @include mq(mobile) {\n      margin-bottom: 30px;\n\n      padding: 0 30px;\n      font-size: 15px;\n    }\n  }\n\n  @include mq(mobile) {\n    width: 90%;\n    padding-top: 25px;\n    margin: auto;\n  }\n\n  h2 {\n    color: $blue;\n    font-size: 20px;\n    text-align: start;\n    margin-bottom: 20px;\n  }\n  p {\n    color: black;\n    text-align: left;\n    // margin-bottom: 30px;\n    @include mq(mobile) {\n      // margin-bottom: 20px;\n    }\n  }\n}\n\n.amount-input {\n  display: flex;\n  // justify-content: ;\n  align-items: center;\n  margin: 10px 0;\n  // margin-bottom: 10px;\n  text-align: left;\n  font-family: $regular;\n  // border-top: 1px solid #ccc;\n  border-bottom: 1px solid #d7d7d7;\n  @include mq(mobile) {\n    margin-bottom: 10px;\n  }\n}\n\n.amount-input label {\n  font-family: $regular;\n  font-weight: bold;\n}\n\n.amount-input input {\n  flex: 1;\n  margin-left: 5px;\n  padding: 8px;\n  border: 1px solid $blue;\n  border-radius: 4px;\n  max-width: 200px;\n}\ninput[type=\"text\"]:focus {\n  border: 2px solid $blue;\n}\n::placeholder {\n  // color: rgb(85, 85, 244);\n  font-family: $regular;\n}\n\n.total-amount {\n  // margin: 30px 0;\n  font-weight: bold;\n  color: black;\n  font-family: $regular;\n  border-top: 1px solid #ccc;\n  padding-top: 25px;\n  margin-bottom: 25px;\n  @include mq(mobile) {\n    // margin: 20px;\n  }\n}\n.options {\n  border-radius: 5px;\n  // border: 1px #4f92f6 solid;\n  // background-color: #f7fafc;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  margin-bottom: 10px;\n  font-family: $regular;\n  @include mq(mobile) {\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n\n  p {\n    text-align: center;\n    margin-bottom: 20px;\n    font-size: 16px;\n    color: black;\n  }\n\n  .payment-div {\n    display: flex;\n    gap: 2rem;\n    justify-content: center;\n    align-items: center;\n    .or-name {\n      font-size: 1.2rem;\n      font-family: $regular;\n      text-transform: uppercase;\n    }\n    .white-color {\n      color: $blue;\n    }\n    p {\n      font-size: 15px;\n    }\n  }\n}\n.options button {\n  margin: 10px;\n  padding: 20px 21px;\n  border: none;\n  cursor: pointer;\n  font-family: $regular;\n  // background-color: #dfebf3;\n  color: $blue;\n  border-radius: 50%;\n  border: 1px solid $blue;\n  .credit-card {\n    // background-color: red;\n    // padding: 10px;\n  }\n  @include mq(mobile) {\n    padding: 13px 14px;\n  }\n}\n\n.options button.selected {\n  // background-color: darkgray;\n  color: white;\n  border-radius: 50%;\n}\n\n.pay-now-btn {\n  display: table;\n  padding: 12px 42px;\n  font-family: $regular;\n  font-size: 26px;\n  border: 2px $blue solid;\n  border-radius: 5px;\n  background-color: white;\n  color: $blue;\n  margin: auto;\n  margin-bottom: 15px;\n\n  &:hover {\n    color: white;\n    background-color: $blue;\n    border: 2px $blue solid;\n    transition: 0.3s all ease-in-out;\n  }\n  @include mq(mobile) {\n    padding: 10px 22px;\n    font-size: 21px;\n  }\n}\n\n.pay-now-btn:disabled {\n  background-color: white;\n  color: $blue;\n  cursor: not-allowed;\n}\n.input-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  row-gap: 5px;\n  position: relative;\n  .error-message-0 {\n    color: red !important;\n    font-size: 9px;\n    // position: absolute !important;\n    // position: absolute !important;\n    // top: 30% !important;\n    // left: 50% !important;\n    // -ms-transform: translate(-50%, -50%) !important;\n    // transform: translate(-50%, -50%) !important;\n    // @include mq(mobile) {\n    //   top: 31% !important;\n    // }\n    position: absolute;\n    left: 5px;\n    /* top: 0%; */\n    bottom: -54%;\n    width: 123%;\n    @include mq(mobile) {\n      position: absolute;\n      left: 7px;\n      /* top: 0%; */\n      bottom: -42%;\n    }\n  }\n}\n.error-message-1 {\n  color: red !important;\n  position: absolute !important;\n  left: 50%;\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  font-size: 9px !important;\n  @include mq(mobile) {\n    width: 100%;\n  }\n}\n.close-btn {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  outline: none;\n  color: $blue !important;\n  @include mq(mobile) {\n    top: 5px;\n    right: 5px;\n  }\n}\n\n.main-div {\n  position: relative;\n  .banner {\n    padding-bottom: 9rem;\n    @include mq(mobile) {\n      padding-bottom: 9rem;\n    }\n    @include mq(tab) {\n      padding-bottom: 11rem;\n    }\n  }\n  .about {\n    padding-top: 15rem;\n    @include mq(mobile) {\n      padding-top: 15rem;\n    }\n  }\n  .donate-page-form {\n    max-width: 900px;\n    position: absolute;\n    top: 0;\n    position: absolute;\n    top: 58%; /* position the top  edge of the element at the middle of the parent */\n    left: 50%; /* position the left edge of the element at the middle of the parent */\n\n    transform: translate(-50%, -57%);\n    width: 80%;\n    @include mq(mobile) {\n      top: 50%; /* position the top  edge of the element at the middle of the parent */\n      left: 50%; /* position the left edge of the element at the middle of the parent */\n      width: 100%;\n      transform: translate(-50%, -50%);\n    }\n    @include mq(tab) {\n      top: 60%;\n    }\n  }\n}\n\n.server-program {\n  .container {\n    width: 90%;\n  }\n  .faq {\n    background-color: #f5f5f5;\n    padding-top: 50px;\n    padding-bottom: 50px;\n\n    .about-wrapper {\n      border-radius: 20px;\n      padding: 3rem;\n      background-color: #3b20e2;\n      display: flex;\n      align-items: flex-start;\n      @include mq(mobile) {\n        padding: 2rem;\n        flex-direction: column;\n      }\n      .about-head {\n        flex: 1;\n        font-size: 30px;\n        color: white;\n        font-family: $regular;\n        @include mq(mobile) {\n          font-size: 25px;\n        }\n      }\n      .about-copy {\n        flex: 2;\n        .copy {\n          color: white;\n          font-family: $regular;\n          font-size: 15px;\n          margin-top: 10px;\n          margin-bottom: 30px;\n          line-height: 1.5;\n          @include mq(mobile) {\n          }\n\n          &:last-child {\n            margin-bottom: unset;\n          }\n        }\n      }\n    }\n    .faq-wrapper {\n      padding: 3rem;\n      margin-top: 50px;\n      border-radius: 20px;\n      box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n      display: flex;\n      justify-content: center;\n      align-items: flex-start;\n      background-color: white;\n      @include mq(mobile) {\n        flex-direction: column;\n        padding: 2rem;\n        margin-top: 30px;\n      }\n      .faq-head {\n        font-family: $regular;\n        font-size: 30px;\n        color: #3b20e2;\n        flex: 1;\n        @include mq(mobile) {\n          font-size: 25px;\n        }\n      }\n      .faq-item {\n        flex: 2;\n        .faq-copy-wrapper {\n          .qt-ans {\n            padding-right: 30px;\n            font-family: $regular;\n            margin-bottom: 30px;\n            @include mq(mobile) {\n              padding-right: 0px;\n            }\n            &:last-child {\n              @include mq(mobile) {\n                margin-bottom: 10px;\n              }\n            }\n\n            .qt {\n              color: $blue;\n              font-weight: 700;\n              font-size: 18px;\n              line-height: 1.5;\n              margin-bottom: 8px;\n              @include mq(mobile) {\n                font-size: 15px;\n                margin-top: 20px;\n              }\n            }\n            .ans {\n              // color: $blue;\n              // font-weight: 700;\n              font-size: 16px;\n              line-height: 1.5;\n              @include mq(mobile) {\n                font-size: 14px;\n              }\n              .link-a {\n                color: $blue;\n                font-weight: 700;\n\n                &:hover {\n                  color: #08d0ae;\n                  transition: all 0.2s ease-in-out;\n                }\n              }\n            }\n          }\n        }\n        .accordion-wrapper {\n          margin-bottom: 30px;\n          .accordion-item {\n            margin-bottom: 10px;\n            // box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n            .accordion-title {\n              background-color: $blue;\n              padding: 10px;\n              cursor: pointer;\n              border: none;\n              width: 100%;\n              text-align: left;\n              display: flex;\n              justify-content: space-between;\n              font-size: 18px;\n              color: white;\n              font-family: $regular;\n              border-radius: 10px;\n              font-size: 20px;\n              @include mq(mobile) {\n                font-size: 15px;\n              }\n            }\n            .accordion-content {\n              padding: 10px;\n              background-color: #fafafa;\n              // border-top: 1px solid #ccc;\n              font-family: $regular;\n              font-size: 16px;\n              border-bottom-left-radius: 10px;\n              border-bottom-right-radius: 10px;\n              box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n              @include mq(mobile) {\n                font-size: 14px;\n              }\n            }\n          }\n        }\n        .faq-acc-ans {\n          .flex-class {\n            display: flex;\n            margin-bottom: 5px;\n            .flex-item {\n              flex: 1;\n            }\n            .flex-item1 {\n              flex: 2;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
